// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faSpinner,
//   faEye,
//   faEyeSlash,
//   faInfoCircle,
//   faPlus,
//   faHeartbeat,
//   faUsers,
//   faCalendarAlt,
//   faLink,
//   faHeart
// } from '@fortawesome/free-solid-svg-icons';
// import { Modal } from 'react-bootstrap';
// import { createPractice, updatePractice, fetchPractice } from '../../../../store/slices/practiceSlice';
// import { useBreadcrumb } from '../../../../contexts/BreadcrumbContext';
// import { toast } from 'react-toastify';
// import { US_STATES, TITLES } from '../../../../utils/constants';
// import FormDetailSkeleton from '../../../../components/SkeletonLoader/FormDetailSkeleton';
// import careProgramService from '../../../../services/careProgramService';
// import './AddPractice.css';

// const AddPractice = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const [searchParams] = useSearchParams();
//   const { isSubmitting: storeIsSubmitting, currentPractice } = useSelector(state => state.practice ?? {});
//   const { updateBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();
//   const [formError, setFormError] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   // Helper for phone formatting (XXX) XXX - XXXX
//   const formatPhoneNumber = (value) => {
//     if (!value) return value;
//     const phoneNumber = value.replace(/[^\d]/g, '');
//     const phoneNumberLength = phoneNumber.length;
//     if (phoneNumberLength < 4) return phoneNumber;
//     if (phoneNumberLength < 7) {
//       return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
//     }
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)} - ${phoneNumber.slice(6, 10)}`;
//   };

//   const validateEmail = (email) => {
//     return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
//   };

//   const normalizeIsoDateToYmd = (value) => {
//     if (!value) return '';
//     const s = String(value);
//     if (s.includes('T')) return s.split('T')[0];
//     return s;
//   };

//   const getStateNameById = (id) => {
//     if (!id) return '';
//     const stateObj = US_STATES.find((s) => s.id === parseInt(id, 10));
//     return stateObj ? stateObj.name : '';
//   };

//   const editId = searchParams.get('editId');
//   const isEditMode = Boolean(editId);

//   const getProgramIcon = (shortName) => {
//     switch (shortName?.toUpperCase()) {
//       case 'RPM': return faHeartbeat;
//       case 'CCM': return faUsers;
//       case 'PCM': return faCalendarAlt;
//       case 'RTM': return faLink;
//       case 'CARDIAC': return faHeart;
//       default: return faInfoCircle;
//     }
//   };

//   const initialFormData = {
//     practice_name: '',
//     status: 'Active',
//     tax_id: '',
//     practice_type: '',
//     enrolled_date: new Date().toISOString().split('T')[0],
//     evitals_monitoring: 'Yes',
//     primary_contact: {
//       address_line_1: '',
//       address_line_2: '',
//       city: '',
//       state: '',
//       state_id: null,
//       zip_code: '',
//       phone: '',
//       fax: '',
//       email: ''
//     },
//     admin: {
//       title: 'Dr.',
//       first_name: '',
//       middle_initial: '',
//       last_name: '',
//       address_line_1: '',
//       address_line_2: '',
//       city: '',
//       state: '',
//       state_id: null,
//       zip_code: '',
//       home_phone: '',
//       cell_phone: '',
//       email: '',
//       fax: '',
//       username: '',
//       password: '',
//       confirm_password: '',
//       status: 'Active',
//       two_way_auth: 'Disabled'
//     },
//     billing_cycles: [
//       {
//         id: 'RPM', program: 'Remote Patient Monitoring (RPM)', icon: faHeartbeat, iconClass: 'icon-rpm', enabled: false, start_date: '', days: '', end_date: '',
//         parameters: { blood_pressure: false, blood_glucose: false, weight: false, oxygen_saturation: false }
//       },
//       { id: 'CCM', program: 'Chronic Care Management (CCM)', icon: faUsers, iconClass: 'icon-ccm', enabled: false, start_date: '', days: '', end_date: '' },
//       { id: 'PCM', program: 'Principal Care Management (PCM)', icon: faCalendarAlt, iconClass: 'icon-pcm', enabled: false, start_date: '', days: '', end_date: '' },
//       { id: 'RTM', program: 'Remote Therapeutic Monitoring (RTM)', icon: faLink, iconClass: 'icon-rtm', enabled: false, start_date: '', days: '', end_date: '' },
//       { id: 'CDM', program: 'Cardiac Device Management', icon: faHeart, iconClass: 'icon-cdm', enabled: false, start_date: '', days: '', end_date: '' }
//     ],
//     email_notifications: {
//       provider: false,
//       practice_caregiver: false,
//       admin: false,
//       system_caregiver: false
//     }
//   };

//   const [formData, setFormData] = useState(initialFormData);
//   const [errors, setErrors] = useState({});
//   const [showValidationModal, setShowValidationModal] = useState(false);

//   useEffect(() => {
//     const fetchPrograms = async () => {
//       try {
//         const response = await careProgramService.getCarePrograms();
//         if (response.success) {
//           const programs = response.data;

//           // Initialize billing cycles from fetched programs
//           const cycles = programs.map(prog => ({
//             id: prog.short_name,
//             program: prog.full_name,
//             icon: getProgramIcon(prog.short_name),
//             iconClass: `icon-${prog.short_name.toLowerCase()}`,
//             enabled: false,
//             start_date: '',
//             days: '',
//             end_date: '',
//             parameters: prog.short_name === 'RPM' ? { blood_pressure: false, blood_glucose: false, weight: false, oxygen_saturation: false } : null
//           }));

//           setFormData(prev => ({
//             ...prev,
//             billing_cycles: cycles
//           }));

//           // If in edit mode, fetch practice data and merge with programs
//           if (isEditMode && editId) {
//             dispatch(fetchPractice(editId));
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching care programs:', error);
//         if (isEditMode && editId) {
//           dispatch(fetchPractice(editId));
//         }
//       }
//     };
//     fetchPrograms();
//   }, [isEditMode, editId, dispatch]);

//   useEffect(() => {
//     const fromDashboard = location.state?.fromDashboard;

//     if (!isEditMode) {
//       const crumbs = fromDashboard
//         ? [{ label: 'Dashboard', path: '/dashboard' }, { label: 'Add Practice', path: null, active: true }]
//         : [{ label: 'Add Practice', path: null, active: true }];
//       updateBreadcrumbs(crumbs);
//     } else {
//       const baseCrumbs = fromDashboard
//         ? [{ label: 'Dashboard', path: '/dashboard' }]
//         : [{ label: 'Practices', path: '/practices' }];

//       updateBreadcrumbs([
//         ...baseCrumbs,
//         { label: 'Edit Practice', path: null, active: true }
//       ]);
//     }

//     return () => clearBreadcrumbs();
//   }, [updateBreadcrumbs, clearBreadcrumbs, isEditMode, location.state]);

//   useEffect(() => {
//     if (isEditMode && currentPractice) {
//       const adminDetails = currentPractice.admin_details || {};
//       setFormData({
//         practice_name: currentPractice.practice_name || '',
//         status: currentPractice.status || 'Active',
//         tax_id: currentPractice.tax_id || '',
//         practice_type: currentPractice.practice_type || '',
//         enrolled_date: normalizeIsoDateToYmd(currentPractice.enrolled_date),
//         evitals_monitoring: currentPractice.evitals_monitoring || 'Yes',
//         primary_contact: {
//           address_line_1: currentPractice.address_1 || '',
//           address_line_2: currentPractice.address_line_2 || '',
//           city: currentPractice.city || '',
//           state: getStateNameById(currentPractice.state),
//           state_id: currentPractice.state || null,
//           zip_code: currentPractice.zip_code || '',
//           phone: currentPractice.phone_1 || '',
//           fax: currentPractice.fax_1 || '',
//           email: currentPractice.email_1 || ''
//         },
//         admin: {
//           title: adminDetails.title || 'Dr.',
//           first_name: adminDetails.first_name || '',
//           middle_initial: adminDetails.middle_initial || '',
//           last_name: adminDetails.last_name || '',
//           address_line_1: adminDetails.address_line_1 || '',
//           address_line_2: adminDetails.address_line_2 || '',
//           city: adminDetails.city || '',
//           state: getStateNameById(adminDetails.state_id),
//           state_id: adminDetails.state_id || null,
//           zip_code: adminDetails.zip_code || '',
//           home_phone: adminDetails.home_phone || '',
//           cell_phone: adminDetails.cell_phone || '',
//           email: adminDetails.email || '',
//           fax: adminDetails.fax || '',
//           username: adminDetails.username || '',
//           password: '',
//           confirm_password: '',
//           status: adminDetails.status || 'Active',
//           two_way_auth: adminDetails.two_way_auth || 'Disabled'
//         },
//         billing_cycles: formData.billing_cycles.map(cycle => {
//           const enrolled = currentPractice.enrolled_programs?.find(p => p.id === cycle.id);

//           if (enrolled) {
//             const start_date = normalizeIsoDateToYmd(enrolled.start_date);
//             const end_date = normalizeIsoDateToYmd(enrolled.end_date);
//             return {
//               ...cycle,
//               enabled: true,
//               start_date,
//               end_date,
//               parameters: enrolled.parameters || cycle.parameters,
//               days: (start_date && end_date) ? Math.floor((new Date(end_date) - new Date(start_date)) / (1000 * 60 * 60 * 24)).toString() : ''
//             };
//           }

//           return cycle;
//         }),
//         email_notifications: {
//           provider: currentPractice.email_notifications_for_provider === 1,
//           practice_caregiver: currentPractice.email_notifications_for_practice_caregiver === 1,
//           admin: currentPractice.email_notifications_for_superadmin === 1,
//           system_caregiver: currentPractice.email_notifications_for_system_caregiver === 1
//         }
//       });
//     }
//   }, [isEditMode, currentPractice]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     if (name.startsWith('email_notifications.')) {
//       const [_, field] = name.split('.');
//       setFormData(prev => ({
//         ...prev,
//         email_notifications: { ...prev.email_notifications, [field]: checked }
//       }));
//       return;
//     }

//     const nameParts = name.split('.');
//     if (nameParts.length === 2) {
//       const [section, field] = nameParts;
//       let processedValue = value;
//       if (field.includes('phone') || field === 'fax') {
//         processedValue = formatPhoneNumber(value);
//       }
//       if (field === 'middle_initial') {
//         processedValue = value.replace(/\s/g, '').slice(0, 1).toUpperCase();
//       }

//       setFormData(prev => ({
//         ...prev,
//         [section]: { ...prev[section], [field]: processedValue }
//       }));

//       if (field === 'state') {
//         const stateObj = US_STATES.find(s => s.name === value);
//         setFormData(prev => ({
//           ...prev,
//           [section]: { ...prev[section], state_id: stateObj ? stateObj.id : null }
//         }));
//       }
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//     }

//     if (errors[name]) {
//       setErrors(prev => {
//         const newErrors = { ...prev };
//         delete newErrors[name];
//         return newErrors;
//       });
//     }
//   };

//   const handleBillingCycleChange = (index, field, value) => {
//     const newCycles = [...formData.billing_cycles];
//     newCycles[index][field] = value;
//     const cycle = newCycles[index];

//     // Reset logic: If days is removed, reset only the end date (keep start date)
//     if (field === 'days' && (value === '' || value === null)) {
//       cycle.end_date = '';
//     }
//     // If start_date is removed, clear end_date and days
//     else if (field === 'start_date' && (value === '' || value === null)) {
//       cycle.days = '';
//       cycle.end_date = '';
//     }
//     // If end_date is removed, clear days
//     else if (field === 'end_date' && (value === '' || value === null)) {
//       cycle.days = '';
//     }

//     // Logic: 
//     // 1. If start_date and days are present, update end_date
//     // 2. If start_date and end_date are present, update days

//     if (field === 'start_date' || field === 'days') {
//       if (cycle.start_date && cycle.days !== '' && !isNaN(parseInt(cycle.days))) {
//         const start = new Date(cycle.start_date);
//         const days = parseInt(cycle.days);
//         const end = new Date(start.getTime() + (days * 24 * 60 * 60 * 1000));
//         cycle.end_date = end.toISOString().split('T')[0];
//       }
//     } else if (field === 'end_date') {
//       if (cycle.start_date && cycle.end_date) {
//         const start = new Date(cycle.start_date);
//         const end = new Date(cycle.end_date);
//         // Reset to midnight for clean day calculation
//         start.setHours(0, 0, 0, 0);
//         end.setHours(0, 0, 0, 0);
//         const diffTime = end.getTime() - start.getTime();
//         const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
//         cycle.days = Math.max(0, diffDays).toString();
//       }
//     }

//     setFormData(prev => ({ ...prev, billing_cycles: newCycles }));
//   };

//   const handleRpmParameterChange = (param, value) => {
//     setFormData(prev => ({
//       ...prev,
//       billing_cycles: prev.billing_cycles.map(cycle =>
//         cycle.id === 'RPM'
//           ? { ...cycle, parameters: { ...cycle.parameters, [param]: value } }
//           : cycle
//       )
//     }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.practice_name) newErrors.practice_name = 'Required';
//     if (!formData.tax_id) newErrors.tax_id = 'Required';
//     if (!formData.practice_type) newErrors.practice_type = 'Required';
//     if (!formData.enrolled_date) newErrors.enrolled_date = 'Required';
//     if (!formData.primary_contact.address_line_1) newErrors['primary_contact.address_line_1'] = 'Required';
//     if (!formData.primary_contact.city) newErrors['primary_contact.city'] = 'Required';
//     if (!formData.primary_contact.state) newErrors['primary_contact.state'] = 'Required';
//     if (!formData.primary_contact.zip_code) newErrors['primary_contact.zip_code'] = 'Required';
//     if (!formData.primary_contact.phone) newErrors['primary_contact.phone'] = 'Required';
//     if (!formData.primary_contact.email) newErrors['primary_contact.email'] = 'Required';
//     else if (!validateEmail(formData.primary_contact.email)) newErrors['primary_contact.email'] = 'Invalid';

//     if (!formData.admin.first_name) newErrors['admin.first_name'] = 'Required';
//     if (!formData.admin.last_name) newErrors['admin.last_name'] = 'Required';
//     if (!formData.admin.username) newErrors['admin.username'] = 'Required';
//     if (!isEditMode) {
//       if (!formData.admin.password) newErrors['admin.password'] = 'Required';
//       if (formData.admin.password !== formData.admin.confirm_password) newErrors['admin.confirm_password'] = 'No match';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) {
//       setShowValidationModal(true);
//       return;
//     }

//     setIsSubmitting(true);
//     setFormError('');
//     try {
//       const payload = {
//         practice_name: formData.practice_name,
//         status: formData.status,
//         tax_id: formData.tax_id,
//         practice_type: formData.practice_type,
//         enrolled_date: formData.enrolled_date,
//         evitals_monitoring: formData.evitals_monitoring,
//         address_1: formData.primary_contact.address_line_1,
//         address_line_2: formData.primary_contact.address_line_2,
//         city: formData.primary_contact.city,
//         state: formData.primary_contact.state_id,
//         zip_code: formData.primary_contact.zip_code,
//         phone_1: formData.primary_contact.phone,
//         fax_1: formData.primary_contact.fax,
//         email_1: formData.primary_contact.email,
//         admin_details: { ...formData.admin, state_id: formData.admin.state_id },
//         billing_cycles: formData.billing_cycles.filter(c => c.enabled),
//         email_notifications_for_provider: Boolean(formData.email_notifications.provider),
//         email_notifications_for_practice_caregiver: Boolean(formData.email_notifications.practice_caregiver),
//         email_notifications_for_superadmin: Boolean(formData.email_notifications.admin),
//         email_notifications_for_system_caregiver: Boolean(formData.email_notifications.system_caregiver)
//       };

//       let result;
//       if (isEditMode) {
//         result = await dispatch(updatePractice({ id: editId, practiceData: payload }));
//       } else {
//         result = await dispatch(createPractice(payload));
//       }

//       if (createPractice.fulfilled.match(result) || updatePractice.fulfilled.match(result)) {
//         toast.success(`Practice ${isEditMode ? 'updated' : 'added'} successfully`);
//         navigate('/dashboard');
//       } else {
//         setFormError(result.payload || 'Failed to save practice');
//       }
//     } catch (err) {
//       setFormError('An unexpected error occurred');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // const handleCancel = () => {
//   //   const fromDashboard = location.state?.fromDashboard;
//   //   navigate(fromDashboard ? '/dashboard' : '/practices');
//   // };

//   const handleCancel = () => navigate('/dashboard');
//   if (isEditMode && !currentPractice) {
//     return (
//       <div className="add-practice-container">
//         <FormDetailSkeleton titleLines={1} fieldRows={12} columns={2} showFooter={true} />
//       </div>
//     );
//   }

//   return (
//     <div className="add-practice-container">
//       <div className="add-practice-form-wrapper">
//         <h2 className="add-practice-main-title">{isEditMode ? 'Edit Practice' : 'Add Practice'}</h2>

//         <form onSubmit={handleSubmit}>
//           {formError && <div className="alert alert-danger mb-4">{formError}</div>}

//           {/* Practice Details Card */}
//           <div className="add-practice-card">
//             <div className="add-practice-card-header">
//               <h5>Practice Details</h5>
//             </div>
//             <div className="add-practice-card-body">
//               <div className="ap-grid ap-grid-2">
//                 <div className="ap-form-group">
//                   <label>Practice Name<span className="ap-required">*</span></label>
//                   <input type="text" name="practice_name" value={formData.practice_name} onChange={handleInputChange} className={`ap-input ${errors.practice_name ? 'is-invalid' : ''}`} placeholder="Enter practice name" />
//                   {errors.practice_name && <span className="ap-error-msg">{errors.practice_name}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Status<span className="ap-required">*</span></label>
//                   <select name="status" value={formData.status} onChange={handleInputChange} className="ap-input">
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="ap-grid ap-grid-4">
//                 <div className="ap-form-group">
//                   <label>Tax ID (EIN)<span className="ap-required">*</span></label>
//                   <input type="text" name="tax_id" value={formData.tax_id} onChange={handleInputChange} className={`ap-input ${errors.tax_id ? 'is-invalid' : ''}`} placeholder="12-3456789" />
//                   {errors.tax_id && <span className="ap-error-msg">{errors.tax_id}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Practice Type<span className="ap-required">*</span></label>
//                   <select name="practice_type" value={formData.practice_type} onChange={handleInputChange} className={`ap-input ${errors.practice_type ? 'is-invalid' : ''}`}>
//                     <option value="">Select type</option>
//                     <option value="Primary Care">Primary Care</option>
//                     <option value="Cardiology">Cardiology</option>
//                     <option value="Internal Medicine">Internal Medicine</option>
//                     <option value="Family Medicine">Family Medicine</option>
//                   </select>
//                   {errors.practice_type && <span className="ap-error-msg">{errors.practice_type}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Enrolled Date<span className="ap-required">*</span></label>
//                   <input type="date" name="enrolled_date" value={formData.enrolled_date} onChange={handleInputChange} className={`ap-input ${errors.enrolled_date ? 'is-invalid' : ''}`} />
//                   {errors.enrolled_date && <span className="ap-error-msg">{errors.enrolled_date}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>eVitals Monitoring<span className="ap-required">*</span></label>
//                   <select name="evitals_monitoring" value={formData.evitals_monitoring} onChange={handleInputChange} className="ap-input">
//                     <option value="Yes">Yes - eVitals monitoring</option>
//                     <option value="No">No - Self monitoring</option>
//                   </select>
//                 </div>
//               </div>

//               {/* Primary Address Tabs */}
//               <div className="ap-tabs">
//                 <div className="ap-tab active">Primary Address</div>
//               </div>

//               <div className="ap-grid ap-grid-1">
//                 <div className="ap-form-group">
//                   <label>Address Line 1<span className="ap-required">*</span></label>
//                   <input type="text" name="primary_contact.address_line_1" value={formData.primary_contact.address_line_1} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.address_line_1'] ? 'is-invalid' : ''}`} placeholder="Street Address" />
//                   {errors['primary_contact.address_line_1'] && <span className="ap-error-msg">{errors['primary_contact.address_line_1']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Address Line 2</label>
//                   <input type="text" name="primary_contact.address_line_2" value={formData.primary_contact.address_line_2} onChange={handleInputChange} className="ap-input" placeholder="Apartment, suite, unit, building, floor, etc." />
//                 </div>
//               </div>

//               <div className="ap-grid ap-grid-3">
//                 <div className="ap-form-group">
//                   <label>City<span className="ap-required">*</span></label>
//                   <input type="text" name="primary_contact.city" value={formData.primary_contact.city} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.city'] ? 'is-invalid' : ''}`} />
//                   {errors['primary_contact.city'] && <span className="ap-error-msg">{errors['primary_contact.city']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>State<span className="ap-required">*</span></label>
//                   <select name="primary_contact.state" value={formData.primary_contact.state} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.state'] ? 'is-invalid' : ''}`}>
//                     <option value="">Select State</option>
//                     {US_STATES.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
//                   </select>
//                   {errors['primary_contact.state'] && <span className="ap-error-msg">{errors['primary_contact.state']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Zip Code<span className="ap-required">*</span></label>
//                   <input type="text" name="primary_contact.zip_code" value={formData.primary_contact.zip_code} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.zip_code'] ? 'is-invalid' : ''}`} />
//                   {errors['primary_contact.zip_code'] && <span className="ap-error-msg">{errors['primary_contact.zip_code']}</span>}
//                 </div>
//               </div>

//               <div className="ap-grid ap-grid-3">
//                 <div className="ap-form-group">
//                   <label>Phone<span className="ap-required">*</span></label>
//                   <input type="text" name="primary_contact.phone" value={formData.primary_contact.phone} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.phone'] ? 'is-invalid' : ''}`} placeholder="123-231-2345" />
//                   {errors['primary_contact.phone'] && <span className="ap-error-msg">{errors['primary_contact.phone']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Fax</label>
//                   <input type="text" name="primary_contact.fax" value={formData.primary_contact.fax} onChange={handleInputChange} className="ap-input" placeholder="123-231-2345" />
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Email<span className="ap-required">*</span></label>
//                   <input type="email" name="primary_contact.email" value={formData.primary_contact.email} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.email'] ? 'is-invalid' : ''}`} placeholder="practice@example.com" />
//                   {errors['primary_contact.email'] && <span className="ap-error-msg">{errors['primary_contact.email']}</span>}
//                 </div>
//               </div>


//             </div>
//           </div>

//           {/* Admin Card */}
//           <div className="add-practice-card">
//             <div className="add-practice-card-header">
//               <h5>Admin</h5>
//             </div>
//             <div className="add-practice-card-body">
//               {/* Using an equal-width 3-column grid to ensure all fields have sufficient and equal space */}
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px' }}>

//                 {/* Row 1: Title, First Name, Username */}
//                 <div className="ap-form-group">
//                   <label>Title</label>
//                   <select name="admin.title" value={formData.admin.title} onChange={handleInputChange} className="ap-input">
//                     {TITLES.map(t => <option key={t.id} value={t.label}>{t.label}</option>)}
//                   </select>
//                 </div>
//                 <div className="ap-form-group">
//                   <label>First Name<span className="ap-required">*</span></label>
//                   <input type="text" name="admin.first_name" value={formData.admin.first_name} onChange={handleInputChange} className={`ap-input ${errors['admin.first_name'] ? 'is-invalid' : ''}`} />
//                   {errors['admin.first_name'] && <span className="ap-error-msg">{errors['admin.first_name']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Username<span className="ap-required">*</span></label>
//                   <input type="text" name="admin.username" value={formData.admin.username} onChange={handleInputChange} className={`ap-input ${errors['admin.username'] ? 'is-invalid' : ''}`} />
//                   {errors['admin.username'] && <span className="ap-error-msg">{errors['admin.username']}</span>}
//                 </div>

//                 {/* Row 2: MI, Last Name, Password */}
//                 <div className="ap-form-group">
//                   <label>M I</label>
//                   <input type="text" name="admin.middle_initial" value={formData.admin.middle_initial} onChange={handleInputChange} className="ap-input" maxLength="1" />
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Last Name<span className="ap-required">*</span></label>
//                   <input type="text" name="admin.last_name" value={formData.admin.last_name} onChange={handleInputChange} className={`ap-input ${errors['admin.last_name'] ? 'is-invalid' : ''}`} />
//                   {errors['admin.last_name'] && <span className="ap-error-msg">{errors['admin.last_name']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Password<span className="ap-required">*</span></label>
//                   <div className="ap-password-wrapper">
//                     <input type={showPassword ? 'text' : 'password'} name="admin.password" value={formData.admin.password} onChange={handleInputChange} className={`ap-input ${errors['admin.password'] ? 'is-invalid' : ''}`} />
//                     <button type="button" className="ap-password-toggle" onClick={() => setShowPassword(!showPassword)}>
//                       <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
//                     </button>
//                   </div>
//                   {errors['admin.password'] && <span className="ap-error-msg">{errors['admin.password']}</span>}
//                 </div>

//                 {/* Row 3: Address Line 1 (span 2), Confirm Password */}
//                 <div className="ap-form-group" style={{ gridColumn: 'span 2' }}>
//                   <label>Address Line 1<span className="ap-required">*</span></label>
//                   <input type="text" name="admin.address_line_1" value={formData.admin.address_line_1} onChange={handleInputChange} className={`ap-input ${errors['admin.address_line_1'] ? 'is-invalid' : ''}`} />
//                   {errors['admin.address_line_1'] && <span className="ap-error-msg">{errors['admin.address_line_1']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Confirm Password<span className="ap-required">*</span></label>
//                   <div className="ap-password-wrapper">
//                     <input type={showConfirmPassword ? 'text' : 'password'} name="admin.confirm_password" value={formData.admin.confirm_password} onChange={handleInputChange} className={`ap-input ${errors['admin.confirm_password'] ? 'is-invalid' : ''}`} />
//                     <button type="button" className="ap-password-toggle" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
//                       <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
//                     </button>
//                   </div>
//                   {errors['admin.confirm_password'] && <span className="ap-error-msg">{errors['admin.confirm_password']}</span>}
//                 </div>

//                 {/* Row 4: Address Line 2 (span 2), Status */}
//                 <div className="ap-form-group" style={{ gridColumn: 'span 2' }}>
//                   <label>Address Line 2</label>
//                   <input type="text" name="admin.address_line_2" value={formData.admin.address_line_2} onChange={handleInputChange} className="ap-input" />
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Status<span className="ap-required">*</span></label>
//                   <select name="admin.status" value={formData.admin.status} onChange={handleInputChange} className="ap-input">
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                 </div>

//                 {/* Row 5: City (span 2), Two Way Authentication */}
//                 <div className="ap-form-group" style={{ gridColumn: 'span 2' }}>
//                   <label>City<span className="ap-required">*</span></label>
//                   <input type="text" name="admin.city" value={formData.admin.city} onChange={handleInputChange} className={`ap-input ${errors['admin.city'] ? 'is-invalid' : ''}`} />
//                   {errors['admin.city'] && <span className="ap-error-msg">{errors['admin.city']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Two Way Authentication<span className="ap-required">*</span></label>
//                   <select name="admin.two_way_auth" value={formData.admin.two_way_auth} onChange={handleInputChange} className="ap-input">
//                     <option value="Disabled">Disabled</option>
//                     <option value="Enabled">Enabled</option>
//                   </select>
//                 </div>

//                 {/* Row 6: State, Zip Code */}
//                 <div className="ap-form-group">
//                   <label>State<span className="ap-required">*</span></label>
//                   <select name="admin.state" value={formData.admin.state} onChange={handleInputChange} className={`ap-input ${errors['admin.state'] ? 'is-invalid' : ''}`}>
//                     <option value="">Select State</option>
//                     {US_STATES.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
//                   </select>
//                   {errors['admin.state'] && <span className="ap-error-msg">{errors['admin.state']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Zip Code<span className="ap-required">*</span></label>
//                   <input type="text" name="admin.zip_code" value={formData.admin.zip_code} onChange={handleInputChange} className={`ap-input ${errors['admin.zip_code'] ? 'is-invalid' : ''}`} />
//                   {errors['admin.zip_code'] && <span className="ap-error-msg">{errors['admin.zip_code']}</span>}
//                 </div>
//                 <div></div>

//                 {/* Row 7: Home Phone, Cell Phone */}
//                 <div className="ap-form-group">
//                   <label>Home Phone<span className="ap-required">*</span></label>
//                   <input type="text" name="admin.home_phone" value={formData.admin.home_phone} onChange={handleInputChange} className={`ap-input ${errors['admin.home_phone'] ? 'is-invalid' : ''}`} placeholder="123-231-2345" />
//                   {errors['admin.home_phone'] && <span className="ap-error-msg">{errors['admin.home_phone']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Cell Phone</label>
//                   <input type="text" name="admin.cell_phone" value={formData.admin.cell_phone} onChange={handleInputChange} className="ap-input" placeholder="123-231-2345" />
//                 </div>
//                 <div></div>

//                 {/* Row 8: Email, Fax */}
//                 <div className="ap-form-group">
//                   <label>Email<span className="ap-required">*</span></label>
//                   <input type="email" name="admin.email" value={formData.admin.email} onChange={handleInputChange} className={`ap-input ${errors['admin.email'] ? 'is-invalid' : ''}`} placeholder="admin@example.com" />
//                   {errors['admin.email'] && <span className="ap-error-msg">{errors['admin.email']}</span>}
//                 </div>
//                 <div className="ap-form-group">
//                   <label>Fax</label>
//                   <input type="text" name="admin.fax" value={formData.admin.fax} onChange={handleInputChange} className="ap-input" placeholder="123-231-2345" />
//                 </div>
//                 <div></div>
//               </div>
//             </div>
//           </div>

//           {/* Billing Cycles and Practice Settings side-by-side */}
//           <div className="ap-side-by-side-grid">
//             {/* Billing Cycles Card */}
//             <div className="add-practice-card" style={{ marginBottom: 0 }}>
//               <div className="add-practice-card-header">
//                 <h5>Care Program Billing Cycles</h5>
//               </div>
//               <div className="add-practice-card-body">
//                 <div className="ap-table-wrapper">
//                   <table className="ap-table">
//                     <thead>
//                       <tr>
//                         <th style={{ width: '40px', textAlign: 'center' }}></th>
//                         <th>Program Name</th>
//                         <th style={{ width: '130px' }}>Start Date</th>
//                         <th style={{ width: '90px' }}>Days</th>
//                         <th style={{ width: '130px' }}>End Date</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {formData.billing_cycles.map((cycle, index) => (
//                         <React.Fragment key={cycle.id}>
//                           <tr>
//                             <td style={{ textAlign: 'center' }}>
//                               <input type="checkbox" checked={cycle.enabled} onChange={(e) => handleBillingCycleChange(index, 'enabled', e.target.checked)} />
//                             </td>
//                             <td>
//                               <div className="ap-program-cell">
//                                 <div className={`ap-program-icon ${cycle.iconClass}`}>
//                                   <FontAwesomeIcon icon={cycle.icon} />
//                                 </div>
//                                 <span className="ap-program-name">{cycle.program}</span>
//                               </div>
//                             </td>
//                             <td>
//                               <input type="date" value={cycle.start_date} onChange={(e) => handleBillingCycleChange(index, 'start_date', e.target.value)} className="ap-table-input" disabled={!cycle.enabled} />
//                             </td>
//                             <td>
//                               <input type="text" value={cycle.days} onChange={(e) => handleBillingCycleChange(index, 'days', e.target.value)} className="ap-table-input" disabled={!cycle.enabled} />
//                             </td>
//                             <td>
//                               <input type="date" value={cycle.end_date} onChange={(e) => handleBillingCycleChange(index, 'end_date', e.target.value)} className="ap-table-input" disabled={!cycle.enabled} />
//                             </td>
//                           </tr>
//                           {cycle.id === 'RPM' && cycle.enabled && (
//                             <tr className="ap-rpm-parameters-row">
//                               <td></td>
//                               <td colSpan="4">
//                                 <div className="ap-rpm-parameters">
//                                   <span className="ap-param-label">Monitoring Parameters:</span>
//                                   {Object.keys(cycle.parameters).map(param => (
//                                     <div key={param} className="ap-param-item">
//                                       <input
//                                         type="checkbox"
//                                         id={`param_${param}`}
//                                         checked={cycle.parameters[param]}
//                                         onChange={(e) => handleRpmParameterChange(param, e.target.checked)}
//                                       />
//                                       <label htmlFor={`param_${param}`}>{param.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</label>
//                                     </div>
//                                   ))}
//                                 </div>
//                               </td>
//                             </tr>
//                           )}
//                         </React.Fragment>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>

//             {/* Practice Settings Card */}
//             <div className="add-practice-card" style={{ marginBottom: 0 }}>
//               <div className="add-practice-card-header">
//                 <h5>Practice Settings</h5>
//               </div>
//               <div className="add-practice-card-body">
//                 <div className="ap-settings-box">
//                   <div className="ap-settings-title">Email Notifications</div>
//                   <div className="ap-settings-desc">Send notifications when a new patient is enrolled</div>
//                   <div className="ap-checkbox-list">
//                     <div className="ap-checkbox-item">
//                       <input type="checkbox" id="email_provider" name="email_notifications.provider" checked={formData.email_notifications.provider} onChange={handleInputChange} />
//                       <label htmlFor="email_provider">Provider</label>
//                     </div>
//                     <div className="ap-checkbox-item">
//                       <input type="checkbox" id="email_caregiver" name="email_notifications.practice_caregiver" checked={formData.email_notifications.practice_caregiver} onChange={handleInputChange} />
//                       <label htmlFor="email_caregiver">Practice Caregiver</label>
//                     </div>
//                     <div className="ap-checkbox-item">
//                       <input type="checkbox" id="email_admin" name="email_notifications.admin" checked={formData.email_notifications.admin} onChange={handleInputChange} />
//                       <label htmlFor="email_admin">Admin</label>
//                     </div>
//                     <div className="ap-checkbox-item">
//                       <input type="checkbox" id="email_system" name="email_notifications.system_caregiver" checked={formData.email_notifications.system_caregiver} onChange={handleInputChange} />
//                       <label htmlFor="email_system">System Caregiver</label>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="ap-actions">
//             <button type="button" className="ap-btn ap-btn-cancel" onClick={handleCancel}>Cancel</button>
//             <button type="submit" className="ap-btn ap-btn-save" disabled={isSubmitting || storeIsSubmitting}>
//               {isSubmitting || storeIsSubmitting ? <><FontAwesomeIcon icon={faSpinner} spin className="me-2" /> Saving...</> : 'Save Practice'}
//             </button>
//           </div>
//         </form>
//       </div>

//       <Modal show={showValidationModal} onHide={() => setShowValidationModal(false)} centered>
//         <Modal.Body className="text-center p-4">
//           <div className="mb-3">
//             <FontAwesomeIcon icon={faInfoCircle} size="3x" className="text-danger" />
//           </div>
//           <h4 className="mb-4">Please fill all required fields</h4>
//           <button className="ap-btn ap-btn-save mx-auto" onClick={() => setShowValidationModal(false)}>OK</button>
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// };

// export default AddPractice;

import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSpinner,
  faEye,
  faEyeSlash,
  faInfoCircle,
  faPlus,
  faList,
  faHeartbeat,
  faUsers,
  faCalendarAlt,
  faLink,
  faHeart,
  faStethoscope, faUserMd, faWheelchair, faAmbulance,
  faHospital, faSyringe, faPills, faBriefcaseMedical, faNotesMedical,
  faPrescriptionBottleAlt, faLungs, faBrain, faTooth, faBone,
  faVirus, faVial, faDna, faMicroscope, faXRay, faThermometerHalf,
  faLaptopMedical, faMobileAlt, faPhoneAlt, faClinicMedical,
  faWaveSquare, faCapsules, faSync, faCloudUploadAlt,
  faCheckCircle, faCircle
} from '@fortawesome/free-solid-svg-icons';
import { Modal } from 'react-bootstrap';
import { createPractice, updatePractice, fetchPractice } from '../../../../store/slices/practiceSlice';
import { useBreadcrumb } from '../../../../contexts/BreadcrumbContext';
import { toast } from 'react-toastify';
import { US_STATES, TITLES, TIME_ZONES, normalizeTimeZone } from '../../../../utils/constants';
import FormDetailSkeleton from '../../../../components/SkeletonLoader/FormDetailSkeleton';
import careProgramService from '../../../../services/careProgramService';
import { getFontAwesomeProgramIcon } from '../../../../utils/careProgramUtils';
import AppDateInput from '../../../../components/Common/AppDateInput/AppDateInput';
import { getTodayDateOnlyLocal } from '../../../../utils/dateOnlyUtils';
import './AddPractice.css';
import EventLogSection from '../../../../components/EventLogSection/EventLogSection';
import useEventLogModalScrollLock from '../../../../hooks/useEventLogModalScrollLock';
import { handleGlobalModalEscape } from '../../../../utils/modalEscape';
import { VALIDATION_SUMMARY_MESSAGE, preserveAvailabilityErrors, clearFieldError, validateRequiredPhone, updateFieldErrorOnChange } from '../../../../utils/formValidation';
import { formatUSPhoneNumber, isCompletePhoneNumber, normalizePhoneDigits, PHONE_VALIDATION_MESSAGE, getPhoneValidationError, extractPhoneDigits } from '../../../../utils/phoneUtils';
import PhoneNumberInput from '../../../../components/Common/PhoneNumberInput/PhoneNumberInput';
import useUsernameEmailAvailability from '../../../../hooks/useUsernameEmailAvailability';
import { sanitizeUsernameInput, getUsernameFormatError, USERNAME_MAX_LENGTH } from '../../../../utils/usernameValidation';
import { resolvePracticeLogoUrl } from '../../../../utils/assetUrls';
import { validateImageUploadFile } from '../../../../utils/imageUploadUtils';
import { isEvitalsMonitoringPractice } from '../../../../utils/practiceMonitoringUtils';
import { normalizeAdminStatus } from '../../../../utils/adminStatus';
import practiceService from '../../../../services/practiceService';

const PRACTICE_STATUS_OPTIONS = ['Active', 'Pending', 'Locked'];

/** Map API/legacy status to enroll form options (Active, Pending, Locked only). */
const normalizePracticeStatusForForm = (status) => {
  const value = String(status ?? 'Active').trim();
  if (PRACTICE_STATUS_OPTIONS.includes(value)) return value;
  if (value === 'Inactive') return 'Pending';
  return 'Active';
};
const RPM_MONITORING_PARAMETER_KEYS = ['blood_pressure', 'blood_glucose', 'weight'];

const RPM_PARAMETER_LABELS = {
  blood_pressure: 'BP',
  blood_glucose: 'Glucose',
  weight: 'Weight'
};

const normalizeRpmParameters = (params) => {
  const source = params && typeof params === 'object' ? params : {};
  return RPM_MONITORING_PARAMETER_KEYS.reduce((acc, key) => {
    acc[key] = Boolean(source[key]);
    return acc;
  }, {});
};

const resolveAdminTitleForForm = (adminDetails = {}) => {
  if (adminDetails.title_id != null && String(adminDetails.title_id).trim() !== '') {
    const byId = TITLES.find((t) => String(t.id) === String(adminDetails.title_id));
    if (byId) return byId.label;
  }
  if (adminDetails.title && TITLES.some((t) => t.label === adminDetails.title)) {
    return adminDetails.title;
  }
  return '';
};

const resolveAdminTwoWayAuthForForm = (adminDetails = {}) => {
  const value = adminDetails.two_way_auth ?? adminDetails.is_two_way_auth;
  return (value === 'Enabled' || value === 1 || value === '1' || value === true) ? 'Enabled' : 'Disabled';
};

/** Legacy DB: users.phone = cell (required), users.cell_phone = home (optional). */
const mapAdminPhonesFromPractice = (adminDetails = {}, practice = {}) => {
  const dbPhone = adminDetails.phone || practice.admin_phone || '';
  const dbCellPhone = adminDetails.cell_phone || practice.admin_cell_phone || '';
  return {
    cell_phone: dbPhone || dbCellPhone || '',
    home_phone: dbPhone ? dbCellPhone : '',
  };
};

const isValidAdminTimeZone = (tz) => Boolean(tz && TIME_ZONES.includes(tz));

const AddPractice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { isSubmitting: storeIsSubmitting, currentPractice } = useSelector(state => state.practice ?? {});
  const { updateBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();

  const logoInputRef = useRef(null);
  const logoPreviewObjectUrlRef = useRef(null);
  const [logoFile, setLogoFile] = useState(null);
  const [logoRemoved, setLogoRemoved] = useState(false);
  const [initialLogoPath, setInitialLogoPath] = useState('');

  const revokeLogoPreviewObjectUrl = useCallback(() => {
    if (logoPreviewObjectUrlRef.current) {
      URL.revokeObjectURL(logoPreviewObjectUrlRef.current);
      logoPreviewObjectUrlRef.current = null;
    }
  }, []);

  const handleLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const logoError = validateImageUploadFile(file, { label: 'Logo' });
    if (logoError) {
      setErrors((prev) => ({ ...prev, practice_logo: logoError }));
      e.target.value = '';
      return;
    }

    setErrors((prev) => {
      if (!prev.practice_logo) return prev;
      const next = { ...prev };
      delete next.practice_logo;
      return next;
    });

    revokeLogoPreviewObjectUrl();
    logoPreviewObjectUrlRef.current = URL.createObjectURL(file);
    setLogoFile(file);
    setLogoRemoved(false);
    setFormData((prev) => ({ ...prev, practice_logo: '' }));
  };

  const handleRemoveLogo = () => {
    revokeLogoPreviewObjectUrl();
    setLogoFile(null);
    setLogoRemoved(Boolean(initialLogoPath));
    setFormData((prev) => ({ ...prev, practice_logo: '' }));
    setErrors((prev) => {
      if (!prev.practice_logo) return prev;
      const next = { ...prev };
      delete next.practice_logo;
      return next;
    });
    if (logoInputRef.current) {
      logoInputRef.current.value = '';
    }
  };

  useEffect(() => () => revokeLogoPreviewObjectUrl(), [revokeLogoPreviewObjectUrl]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPasswordCriteria, setShowPasswordCriteria] = useState(false);

  const formatPhoneNumber = formatUSPhoneNumber;

  const validateEmail = (email) => {
    return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  };

  const getEnabledRpmCycle = (cycles) => (cycles || []).find((cycle) => cycle.id === 'RPM' && cycle.enabled);

  const hasAtLeastOneRpmMonitoringParameter = (cycles) => {
    const rpmCycle = getEnabledRpmCycle(cycles);
    if (!rpmCycle) return true;
    const params = rpmCycle.parameters || {};
    return Object.values(params).some(Boolean);
  };

  const parseYesNoFlag = (value) => {
    if (value === true || value === 1 || value === '1') return true;
    if (value === false || value === 0 || value === '0') return false;
    if (value == null || value === '') return null;
    const normalized = String(value).trim().toLowerCase();
    if (normalized === 'true' || normalized === 'yes') return true;
    if (normalized === 'false' || normalized === 'no') return false;
    return null;
  };

  const normalizeIsoDateToYmd = (value) => {
    if (!value) return '';
    const s = String(value);
    if (s.includes('T')) return s.split('T')[0];
    return s;
  };

  const buildDefaultBillingCycles = (programs) => {
    const allowedPrograms = new Set(['RPM', 'CCM', 'PCM']);
    return programs
      .filter((prog) => allowedPrograms.has(String(prog.short_name || '').trim().toUpperCase()))
      .sort((a, b) => {
        const order = { RPM: 0, CCM: 1, PCM: 2 };
        const aKey = String(a.short_name || '').trim().toUpperCase();
        const bKey = String(b.short_name || '').trim().toUpperCase();
        return (order[aKey] ?? 99) - (order[bKey] ?? 99);
      })
      .map((prog) => ({
        id: prog.short_name,
        program: prog.full_name.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()),
        icon: getProgramIcon(prog),
        iconClass: `icon-${prog.short_name.toLowerCase()}`,
        badgeColor: prog.badge_color,
        enabled: false,
        start_date: '',
        days: '',
        end_date: '',
        parameters: prog.short_name === 'RPM' ? normalizeRpmParameters() : null
      }));
  };

  const buildBillingCyclesForPractice = (catalog, practice) => {
    if (!Array.isArray(catalog) || catalog.length === 0) return [];

    const enrolled = practice?.enrolled_programs || [];

    return catalog.map((cycle) => {
      const cycleKey = String(cycle.id || '').trim().toLowerCase();
      const enrolledMatch = enrolled.find((p) => {
        const enrolledKey = String(p.short_name || p.id || '').trim().toLowerCase();
        return enrolledKey === cycleKey;
      });

      let start_date = '';
      let end_date = '';
      let days = '';

      if (enrolledMatch) {
        start_date = normalizeIsoDateToYmd(enrolledMatch.start_date);
        end_date = normalizeIsoDateToYmd(enrolledMatch.end_date);
      } else if (cycleKey === 'rpm' && practice) {
        start_date = normalizeIsoDateToYmd(practice.rpm_start_date || practice.billing_from_date);
        end_date = normalizeIsoDateToYmd(practice.rpm_end_date || practice.billing_to_date);
        if (practice.rpm_validity_days != null && practice.rpm_validity_days !== '') {
          days = String(practice.rpm_validity_days);
        }
      }

      if (start_date && end_date) {
        const diffMs = new Date(end_date).getTime() - new Date(start_date).getTime();
        if (Number.isFinite(diffMs) && diffMs >= 0) {
          // +1 because both start and end days are inclusive (Aug 1–Aug 3 = 3 days)
          days = String(Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1);
        }
      } else if (start_date && days && !end_date) {
        const end = new Date(start_date.replace(/-/g, '/'));
        if (!Number.isNaN(end.getTime())) {
          end.setDate(end.getDate() + (Number.parseInt(days, 10) || 0));
          const yyyy = end.getFullYear();
          const mm = String(end.getMonth() + 1).padStart(2, '0');
          const dd = String(end.getDate()).padStart(2, '0');
          end_date = `${yyyy}-${mm}-${dd}`;
        }
      }

      const enabled = Boolean(enrolledMatch || (cycleKey === 'rpm' && start_date));

      if (!enabled) {
        return { ...cycle, enabled: false, start_date: '', days: '', end_date: '' };
      }

      return {
        ...cycle,
        enabled: true,
        start_date,
        end_date,
        days,
        parameters: cycleKey === 'rpm'
          ? normalizeRpmParameters(enrolledMatch?.parameters || cycle.parameters)
          : cycle.parameters
      };
    });
  };

  const getStateNameById = (id) => {
    if (!id) return '';
    const stateObj = US_STATES.find((s) => s.id === parseInt(id, 10));
    return stateObj ? stateObj.name : '';
  };

  const editId = searchParams.get('editId');
  const isEditMode = Boolean(editId);
  const [showEventLogsModal, setShowEventLogsModal] = useState(false);
  const logOverlayRef = useRef(null);
  const logContainerRef = useRef(null);
  useEventLogModalScrollLock(showEventLogsModal, logOverlayRef, logContainerRef);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [editId, location.key]);
  const [loadedCredentials, setLoadedCredentials] = useState({ username: '', email: '' });
  const [isFormInitialized, setIsFormInitialized] = useState(false);

  const getProgramIcon = getFontAwesomeProgramIcon;

  const initialFormData = {
    practice_name: '',
    practice_logo: '',
    status: 'Active',
    tax_id: '',
    practice_type: '',
    enrolled_date: '',
    evitals_monitoring: 'Yes',
    primary_contact: {
      address_line_1: '',
      address_line_2: '',
      city: '',
      state: '',
      state_id: null,
      zip_code: '',
      phone: '',
      fax: '',
      email: ''
    },
    admin: {
      id: null,
      title: '',
      first_name: '',
      middle_initial: '',
      last_name: '',
      address_line_1: '',
      address_line_2: '',
      city: '',
      state: '',
      state_id: null,
      zip_code: '',
      home_phone: '',
      cell_phone: '',
      email: '',
      fax: '',
      username: '',
      password: '',
      confirm_password: '',
      status: 'Active',
      two_way_auth: 'Disabled',
      time_zone: ''
    },
    billing_cycles: [],
    buying_device: null,
    leasing_device: null,
    email_notifications: {
      provider: false,
      practice_caregiver: false,
      admin: false,
      system_caregiver: false
    }
  };

  const [formData, setFormData] = useState(initialFormData);
  const [careProgramCatalog, setCareProgramCatalog] = useState([]);
  const excludeUserId = isEditMode
    ? (formData.admin?.id ?? currentPractice?.admin_details?.id ?? null)
    : null;
  const { scheduleUsernameCheck, scheduleEmailCheck, handleUsernamePaste, handleUsernameBlur, handleEmailPaste } = useUsernameEmailAvailability({
    excludeUserId,
    originalUsername: loadedCredentials.username,
    originalEmail: loadedCredentials.email,
  });
  const [checkingTaxId, setCheckingTaxId] = useState(false);
  const taxIdTimerRef = useRef(null);
  const taxIdSeqRef = useRef(0);

  useEffect(() => () => {
    if (taxIdTimerRef.current) clearTimeout(taxIdTimerRef.current);
  }, []);

  const originalTaxId = useMemo(() => {
    return isEditMode ? (currentPractice?.tax_id || '') : '';
  }, [isEditMode, currentPractice?.tax_id]);

  const runTaxIdCheck = useCallback(async (taxIdVal) => {
    const val = String(taxIdVal || '').trim();
    if (!/^\d{2}-\d{7}$/.test(val)) return true;
    if (originalTaxId && val.toLowerCase() === originalTaxId.toLowerCase()) {
      setErrors(prev => {
        if (prev.tax_id === 'This Tax ID is already registered to another practice.' || prev.tax_id?.includes('already')) {
          const { tax_id, ...rest } = prev;
          return rest;
        }
        return prev;
      });
      return true;
    }
    const seq = ++taxIdSeqRef.current;
    setCheckingTaxId(true);
    try {
      const res = await practiceService.checkTaxId(val, isEditMode ? editId : null);
      if (seq !== taxIdSeqRef.current) return null;
      if (res?.data && res.data.success) {
        if (!res.data.available) {
          setErrors(prev => ({ ...prev, tax_id: res.data.message || 'This Tax ID is already registered to another practice.' }));
          return false;
        } else {
          setErrors(prev => {
            if (prev.tax_id === 'This Tax ID is already registered to another practice.' || prev.tax_id?.includes('already')) {
              const { tax_id, ...rest } = prev;
              return rest;
            }
            return prev;
          });
          return true;
        }
      }
      return null;
    } catch (err) {
      console.warn('Tax ID check failed:', err);
      return null;
    } finally {
      if (seq === taxIdSeqRef.current) {
        setCheckingTaxId(false);
      }
    }
  }, [originalTaxId, isEditMode, editId]);

  const scheduleTaxIdCheck = useCallback((val, immediate = false) => {
    if (taxIdTimerRef.current) {
      clearTimeout(taxIdTimerRef.current);
      taxIdTimerRef.current = null;
    }
    if (!/^\d{2}-\d{7}$/.test(val)) return;
    if (originalTaxId && val.toLowerCase() === originalTaxId.toLowerCase()) {
      setErrors(prev => {
        if (prev.tax_id === 'This Tax ID is already registered to another practice.' || prev.tax_id?.includes('already')) {
          const { tax_id, ...rest } = prev;
          return rest;
        }
        return prev;
      });
      return;
    }
    if (immediate) {
      runTaxIdCheck(val);
    } else {
      taxIdTimerRef.current = setTimeout(() => {
        runTaxIdCheck(val);
      }, 500);
    }
  }, [originalTaxId, runTaxIdCheck]);

  const handleTaxIdBlur = useCallback((e) => {
    const val = String(e?.target?.value ?? formData.tax_id ?? '').trim();
    if (val && !/^\d{2}-\d{7}$/.test(val)) {
      setErrors(prev => ({ ...prev, tax_id: 'Must be a valid Tax ID (XX-XXXXXXX)' }));
    } else if (val && /^\d{2}-\d{7}$/.test(val)) {
      scheduleTaxIdCheck(val, true);
    }
  }, [formData.tax_id, scheduleTaxIdCheck]);

  const [initialFormDataStr, setInitialFormDataStr] = useState('');
  const hasLogoChanges = logoFile !== null || logoRemoved;
  const isChanged = useMemo(() => {
    if (!isEditMode || !initialFormDataStr) return true;
    return JSON.stringify(formData) !== initialFormDataStr || hasLogoChanges;
  }, [formData, initialFormDataStr, isEditMode, hasLogoChanges]);
  const [errors, setErrors] = useState({});
  const [showValidationModal, setShowValidationModal] = useState(false);

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const response = await careProgramService.getCarePrograms();
        if (response.success) {
          const programs = response.data;
          const cycles = buildDefaultBillingCycles(programs);
          setCareProgramCatalog(cycles);

          if (!isEditMode) {
            setFormData((prev) => ({
              ...prev,
              billing_cycles: cycles
            }));
          }

          if (isEditMode && editId) {
            dispatch(fetchPractice(editId));
          }
        }
      } catch (error) {
        console.error('Error fetching care programs:', error);
        if (isEditMode && editId) {
          dispatch(fetchPractice(editId));
        }
      }
    };
    fetchPrograms();
  }, [isEditMode, editId, dispatch]);

  useEffect(() => {
    const fromDashboard = location.state?.fromDashboard;

    if (!isEditMode) {
      const crumbs = fromDashboard
        ? [{ label: 'Dashboard', path: '/dashboard' }, { label: 'Add Practice', path: null, active: true }]
        : [{ label: 'Add Practice', path: null, active: true }];
      updateBreadcrumbs(crumbs);
    } else {
      const baseCrumbs = fromDashboard
        ? [{ label: 'Dashboard', path: '/dashboard' }]
        : [{ label: 'Practices', path: '/practices' }];

      updateBreadcrumbs([
        ...baseCrumbs,
        { label: 'Edit Practice', path: null, active: true }
      ]);
    }

    return () => clearBreadcrumbs();
  }, [updateBreadcrumbs, clearBreadcrumbs, isEditMode, location.state]);

  useEffect(() => {
    // Only hydrate from a full practice payload for THIS editId.
    // Dashboard summary shares currentPractice but has no admin_details — initializing
    // from it caused stale/empty admin email and flaky "username already taken" checks.
    const practiceMatchesEdit =
      isEditMode
      && currentPractice
      && Number(currentPractice.id) === Number(editId)
      && currentPractice.admin_details?.id
      && careProgramCatalog.length > 0;

    if (practiceMatchesEdit) {
      const adminDetails = currentPractice.admin_details || {};
      const newFormData = {
        practice_name: currentPractice.practice_name || '',
        practice_logo: currentPractice.practice_logo || '',
        status: normalizePracticeStatusForForm(currentPractice.status),
        tax_id: currentPractice.tax_id || '',
        practice_type: currentPractice.practice_type || '',
        enrolled_date: normalizeIsoDateToYmd(currentPractice.enrolled_date),
        evitals_monitoring: currentPractice.evitals_monitoring || 'Yes',
        primary_contact: {
          address_line_1: currentPractice.address_1 || '',
          address_line_2: currentPractice.address_line_2 || '',
          city: currentPractice.city || '',
          state: getStateNameById(currentPractice.state),
          state_id: currentPractice.state || null,
          zip_code: currentPractice.zip_code || '',
          phone: currentPractice.phone_1 || '',
          fax: currentPractice.fax_1 || '',
          email: currentPractice.email_1 || ''
        },
        admin: {
          id: adminDetails.id || null,
          title: resolveAdminTitleForForm(adminDetails),
          first_name: adminDetails.first_name || '',
          middle_initial: adminDetails.middle_initial || adminDetails.middle_name || '',
          last_name: adminDetails.last_name || '',
          address_line_1: adminDetails.address_line_1 || '',
          address_line_2: adminDetails.address_line_2 || '',
          city: adminDetails.city || '',
          state: getStateNameById(adminDetails.state_id),
          state_id: adminDetails.state_id || null,
          zip_code: adminDetails.zip_code || '',
          ...mapAdminPhonesFromPractice(adminDetails, currentPractice),
          email: adminDetails.email || currentPractice.admin_email || '',
          fax: adminDetails.fax || currentPractice.admin_fax || '',
          username: adminDetails.username || '',
          password: '',
          confirm_password: '',
          status: normalizeAdminStatus(adminDetails.status),
          two_way_auth: resolveAdminTwoWayAuthForForm(adminDetails),
          time_zone: normalizeTimeZone(adminDetails.time_zone || adminDetails.timeZone || adminDetails.timezone) || ''
        },
        billing_cycles: buildBillingCyclesForPractice(careProgramCatalog, currentPractice),
        buying_device: parseYesNoFlag(currentPractice.buying_listing_device),
        leasing_device: parseYesNoFlag(currentPractice.leasing_listing_device),
        email_notifications: {
          provider: currentPractice.email_notifications_for_provider === 1,
          practice_caregiver: currentPractice.email_notifications_for_practice_caregiver === 1,
          admin: currentPractice.email_notifications_for_superadmin === 1,
          system_caregiver: currentPractice.email_notifications_for_system_caregiver === 1
        }
      };

      setFormData(newFormData);
      setInitialFormDataStr(JSON.stringify(newFormData));
      setInitialLogoPath(currentPractice.practice_logo || '');
      revokeLogoPreviewObjectUrl();
      setLogoFile(null);
      setLogoRemoved(false);
      setLoadedCredentials({
        username: adminDetails.username || '',
        email: adminDetails.email || currentPractice.admin_email || '',
      });
      setErrors((prev) => {
        const next = { ...prev };
        delete next['admin.username'];
        delete next['admin.email'];
        return next;
      });

      setIsFormInitialized(true);
    } else if (!isEditMode) {
      setFormData(prev => ({
        ...initialFormData,
        billing_cycles: prev.billing_cycles.map(cycle => ({
          ...cycle,
          enabled: false,
          start_date: '',
          days: '',
          end_date: '',
          parameters: cycle.id === 'RPM' ? normalizeRpmParameters() : null
        }))
      }));
      setInitialFormDataStr('');
      setInitialLogoPath('');
      revokeLogoPreviewObjectUrl();
      setLogoFile(null);
      setLogoRemoved(false);
      setErrors({});
      setLoadedCredentials({ username: '', email: '' });
      setIsFormInitialized(true);
    } else if (isEditMode) {
      setIsFormInitialized(false);
    }
  }, [isEditMode, editId, currentPractice, careProgramCatalog, location.key, revokeLogoPreviewObjectUrl]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    clearFieldError(setErrors, name);

    if (name === 'tax_id') {
      let filteredValue = value.replace(/[^\d]/g, '');
      if (filteredValue.length > 2) {
        filteredValue = `${filteredValue.slice(0, 2)}-${filteredValue.slice(2, 9)}`;
      }
      setFormData(prev => ({ ...prev, tax_id: filteredValue }));
      if (errors.tax_id) {
        setErrors(prev => { const { tax_id, ...rest } = prev; return rest; });
      }
      if (filteredValue.length === 10) {
        scheduleTaxIdCheck(filteredValue);
      }
      return;
    }

    if (name === 'primary_contact.zip_code') {
      let filteredValue = value.replace(/[^\d]/g, '');
      if (filteredValue.length > 5) filteredValue = filteredValue.slice(0, 5);
      setFormData(prev => ({
        ...prev,
        primary_contact: { ...prev.primary_contact, zip_code: filteredValue }
      }));
      if (errors['primary_contact.zip_code']) {
        setErrors(prev => { const { 'primary_contact.zip_code': _, ...rest } = prev; return rest; });
      }
      return;
    }

    if (name === 'admin.zip_code') {
      let filteredValue = value.replace(/[^\d]/g, '');
      if (filteredValue.length > 5) filteredValue = filteredValue.slice(0, 5);
      setFormData(prev => ({
        ...prev,
        admin: { ...prev.admin, zip_code: filteredValue }
      }));
      if (errors['admin.zip_code']) {
        setErrors(prev => { const { 'admin.zip_code': _, ...rest } = prev; return rest; });
      }
      return;
    }

    if (name === 'evitals_monitoring') {
      setFormData((prev) => ({
        ...prev,
        evitals_monitoring: value,
        email_notifications: {
          ...prev.email_notifications,
          system_caregiver: value === 'No' ? false : prev.email_notifications.system_caregiver,
        },
      }));
      return;
    }

    if (name.startsWith('email_notifications.')) {
      const [_, field] = name.split('.');
      setFormData(prev => ({
        ...prev,
        email_notifications: { ...prev.email_notifications, [field]: checked }
      }));
      if (errors.email_notifications) {
        setErrors(prev => { const { email_notifications, ...rest } = prev; return rest; });
      }
      return;
    }

    const nameParts = name.split('.');
    if (nameParts.length === 2) {
      const [section, field] = nameParts;
      let processedValue = value;
      if (field.includes('phone') || field === 'fax') {
        const formatted = value;
        const digits = extractPhoneDigits(formatted);
        setFormData((prev) => ({
          ...prev,
          [section]: { ...prev[section], [field]: formatted },
        }));
        if (digits.length > 0 && !isCompletePhoneNumber(digits)) {
          setErrors((prev) => ({ ...prev, [`${section}.${field}`]: PHONE_VALIDATION_MESSAGE }));
        } else if (errors[`${section}.${field}`]) {
          setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[`${section}.${field}`];
            return newErrors;
          });
        }
        return;
      }
      if (field === 'middle_initial') {
        processedValue = value.replace(/[^a-zA-Z\s]/g, '');
      }
      if (section === 'admin' && (field === 'first_name' || field === 'last_name' || field === 'middle_initial')) {
        processedValue = processedValue.replace(/[^a-zA-Z\s]/g, '');
      }
      if (field === 'address_line_1' || field === 'address_line_2' || field === 'city') {
        processedValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
      }
      if (field === 'email') {
        processedValue = value.replace(/[^a-zA-Z0-9._@-]/g, '');
      }
      if (field === 'username') {
        processedValue = sanitizeUsernameInput(value);
      }

      if (field === 'time_zone') {
        setFormData(prev => ({
          ...prev,
          [section]: { ...prev[section], [field]: processedValue }
        }));
        updateFieldErrorOnChange(setErrors, `${section}.${field}`, processedValue, {
          required: true,
          requiredMessage: 'Required',
        });
        return;
      }

      setFormData(prev => ({
        ...prev,
        [section]: { ...prev[section], [field]: processedValue }
      }));

      if (field === 'state') {
        const stateObj = US_STATES.find(s => s.name === value);
        setFormData(prev => ({
          ...prev,
          [section]: { ...prev[section], state_id: stateObj ? stateObj.id : null }
        }));
      }

      const nestedErrorKey = `${section}.${field}`;
      if (String(processedValue ?? '').trim()) {
        updateFieldErrorOnChange(setErrors, nestedErrorKey, processedValue);
      }

      if (section === 'admin' && field === 'username') {
        const cleaned = String(processedValue || '');
        const formatError = getUsernameFormatError(cleaned);
        if (formatError) {
          setErrors(prev => ({ ...prev, 'admin.username': formatError }));
        } else if (cleaned) {
          // In edit mode wait until admin id/credentials are loaded so we never
          // falsely flag this practice admin's own username as taken.
          if (!isEditMode || excludeUserId) {
            scheduleUsernameCheck(cleaned, setErrors, 'admin.username');
          }
        }
      }
      if (section === 'admin' && field === 'email') {
        const trimmed = String(processedValue || '').trim();
        if (trimmed && validateEmail(trimmed)) {
          if (!isEditMode || excludeUserId) {
            scheduleEmailCheck(trimmed, setErrors, 'admin.email');
          }
        }
      }
    } else {
      let finalValue = value;
      if (name === 'tax_id') {
        const cleaned = value.replace(/\D/g, '');
        if (cleaned.length > 2) {
          finalValue = `${cleaned.slice(0, 2)}-${cleaned.slice(2, 9)}`;
        } else {
          finalValue = cleaned;
        }
      } else if (name === 'practice_name') {
        finalValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
      }
      setFormData(prev => ({ ...prev, [name]: finalValue }));
    }

    if (name === 'admin.password') {
      const pass = value;
      const passErrors = [];
      if (pass.length > 0) {
        if (pass.length < 8) passErrors.push('8+ chars');
        if (!/[A-Z]/.test(pass)) passErrors.push('1 uppercase');
        if (!/[a-z]/.test(pass)) passErrors.push('1 lowercase');
        if (!/[0-9]/.test(pass)) passErrors.push('1 number');
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(pass)) passErrors.push('1 special char');
      }

      setErrors(prev => {
        const newErrors = { ...prev };
        if (passErrors.length > 0) {
          newErrors['admin.password'] = `Missing: ${passErrors.join(', ')}`;
        } else {
          delete newErrors['admin.password'];
        }

        if (formData.admin.confirm_password && pass !== formData.admin.confirm_password) {
          newErrors['admin.confirm_password'] = 'Passwords do not match';
        } else if (newErrors['admin.confirm_password'] === 'Passwords do not match') {
          delete newErrors['admin.confirm_password'];
        }
        return newErrors;
      });
    } else if (name === 'admin.confirm_password') {
      setErrors(prev => {
        const newErrors = { ...prev };
        if (value !== formData.admin.password) {
          newErrors['admin.confirm_password'] = 'Passwords do not match';
        } else {
          delete newErrors['admin.confirm_password'];
        }
        return newErrors;
      });
    } else {
      if (errors[name]) {
        setErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }
  };

  const handleBillingCycleChange = (index, field, value) => {
    const newCycles = [...formData.billing_cycles];
    if (field === 'days') {
      value = String(value ?? '').replace(/\D/g, '');
    }
    newCycles[index][field] = value;
    const cycle = newCycles[index];

    if (field === 'enabled' && value === true && errors.billing_cycles) {
      setErrors(prev => { const { billing_cycles, ...rest } = prev; return rest; });
    }

    if (field === 'enabled' && value === false) {
      cycle.start_date = '';
      cycle.days = '';
      cycle.end_date = '';
    }

    const clearingRpm = field === 'enabled' && value === false && cycle.id === 'RPM';
    if (clearingRpm) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next.buying_device;
        delete next.leasing_device;
        delete next.rpm_monitoring_parameters;
        return next;
      });
    }

    if (field === 'days' && (value === '' || value === null)) {
      cycle.end_date = '';
    }
    else if (field === 'start_date' && (value === '' || value === null)) {
      cycle.days = '';
      cycle.end_date = '';
    }
    else if (field === 'end_date' && (value === '' || value === null)) {
      cycle.days = '';
    }

    if (field === 'start_date' || field === 'days') {
      if (cycle.start_date && cycle.days !== '' && !isNaN(parseInt(cycle.days))) {
        const start = new Date(cycle.start_date);
        const days = parseInt(cycle.days);
        // Subtract 1 so that a 3-day period from Aug 1 ends on Aug 3 (inclusive)
        const end = new Date(start.getTime() + ((days - 1) * 24 * 60 * 60 * 1000));
        cycle.end_date = end.toISOString().split('T')[0];
      }
    } else if (field === 'end_date') {
      if (cycle.start_date && cycle.end_date) {
        const start = new Date(cycle.start_date);
        const end = new Date(cycle.end_date);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        const diffTime = end.getTime() - start.getTime();
        // +1 because both start and end days are inclusive (Aug 1–Aug 3 = 3 days)
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
        cycle.days = Math.max(1, diffDays).toString();
      }
    }

    setFormData((prev) => ({
      ...prev,
      billing_cycles: newCycles,
      ...(clearingRpm ? { buying_device: null, leasing_device: null } : {})
    }));
  };

  const handleRpmDeviceFlagChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const next = { ...prev };
      delete next[field];
      return next;
    });
  };

  const handleRpmParameterChange = (param, value) => {
    if (!RPM_MONITORING_PARAMETER_KEYS.includes(param)) return;
    setFormData((prev) => {
      const nextCycles = prev.billing_cycles.map((cycle) =>
        cycle.id === 'RPM'
          ? { ...cycle, parameters: normalizeRpmParameters({ ...(cycle.parameters || {}), [param]: value }) }
          : cycle
      );
      return { ...prev, billing_cycles: nextCycles };
    });

    if (value) {
      setErrors((prev) => {
        if (!prev.rpm_monitoring_parameters) return prev;
        const { rpm_monitoring_parameters, ...rest } = prev;
        return rest;
      });
    }
  };
  const isFormValid = () => {
    if (!formData.practice_name) return false;
    if (!formData.tax_id || !/^\d{2}-\d{7}$/.test(formData.tax_id)) return false;
    if (!formData.practice_type) return false;
    if (!formData.enrolled_date) return false;
    if (!formData.primary_contact.address_line_1) return false;
    if (!formData.primary_contact.city) return false;
    if (!formData.primary_contact.state) return false;
    if (!formData.primary_contact.zip_code || String(formData.primary_contact.zip_code).length !== 5) return false;
    if (!formData.primary_contact.phone || !isCompletePhoneNumber(formData.primary_contact.phone)) return false;
    if (formData.primary_contact.fax && !isCompletePhoneNumber(formData.primary_contact.fax)) return false;
    if (!formData.primary_contact.email || !validateEmail(formData.primary_contact.email)) return false;

    if (!formData.admin.first_name) return false;
    if (!formData.admin.last_name) return false;
    if (!formData.admin.username) return false;
    if (!formData.admin.zip_code || String(formData.admin.zip_code).length !== 5) return false;
    if (!formData.admin.address_line_1) return false;
    if (!formData.admin.city) return false;
    if (!formData.admin.state) return false;
    if (!formData.admin.cell_phone || !isCompletePhoneNumber(formData.admin.cell_phone)) return false;
    if (formData.admin.home_phone && !isCompletePhoneNumber(formData.admin.home_phone)) return false;
    if (formData.admin.fax && !isCompletePhoneNumber(formData.admin.fax)) return false;
    if (!formData.admin.email || !validateEmail(formData.admin.email)) return false;
    if (!isValidAdminTimeZone(formData.admin.time_zone)) return false;
    if (!isEditMode) {
      const pass = formData.admin.password;
      if (!pass || pass.length < 8 || !/[A-Z]/.test(pass) || !/[a-z]/.test(pass) || !/[0-9]/.test(pass) || !/[!@#$%^&*(),.?":{}|<>]/.test(pass)) return false;
      if (pass !== formData.admin.confirm_password) return false;
    }

    const hasEnabledCycle = formData.billing_cycles.some(cycle => cycle.enabled === true);
    if (!hasEnabledCycle) return false;

    // Check if any enabled cycle is missing its billing period
    const hasIncompleteCycles = formData.billing_cycles.some(cycle => cycle.enabled && (!cycle.start_date || !cycle.days || !cycle.end_date));
    if (hasIncompleteCycles) return false;

    if (!hasAtLeastOneRpmMonitoringParameter(formData.billing_cycles)) return false;

    const emailNotificationValues = isEvitalsMonitoringPractice(formData.evitals_monitoring)
      ? Object.values(formData.email_notifications)
      : Object.entries(formData.email_notifications)
        .filter(([key]) => key !== 'system_caregiver')
        .map(([, value]) => value);
    const hasEmailNotification = emailNotificationValues.some((value) => value === true);
    if (!hasEmailNotification) return false;

    return true;
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.practice_name) newErrors.practice_name = 'Required';
    if (!formData.tax_id) newErrors.tax_id = 'Required';
    else if (!/^\d{2}-\d{7}$/.test(formData.tax_id)) {
      newErrors.tax_id = 'Must be a valid Tax ID (XX-XXXXXXX)';
    }
    if (!formData.practice_type) newErrors.practice_type = 'Required';
    if (!formData.enrolled_date) newErrors.enrolled_date = 'Required';
    if (!formData.primary_contact.address_line_1) newErrors['primary_contact.address_line_1'] = 'Required';
    if (!formData.primary_contact.city) newErrors['primary_contact.city'] = 'Required';
    if (!formData.primary_contact.state) newErrors['primary_contact.state'] = 'Required';
    if (!formData.primary_contact.zip_code) newErrors['primary_contact.zip_code'] = 'Required';
    else if (formData.primary_contact.zip_code && String(formData.primary_contact.zip_code).length !== 5) {
      newErrors['primary_contact.zip_code'] = 'Zip code must be exactly 5 digits';
    }
    const primaryPhoneError = getPhoneValidationError(formData.primary_contact.phone, { label: 'Phone' });
    if (primaryPhoneError) newErrors['primary_contact.phone'] = primaryPhoneError;

    const primaryFaxError = getPhoneValidationError(formData.primary_contact.fax, { required: false, label: 'Fax' });
    if (primaryFaxError) newErrors['primary_contact.fax'] = primaryFaxError;
    if (!formData.primary_contact.email) newErrors['primary_contact.email'] = 'Required';
    else if (!validateEmail(formData.primary_contact.email)) newErrors['primary_contact.email'] = 'Invalid';

    if (!formData.admin.first_name) newErrors['admin.first_name'] = 'Required';
    if (!formData.admin.last_name) newErrors['admin.last_name'] = 'Required';
    if (!formData.admin.username) newErrors['admin.username'] = 'Required';
    else {
      const formatError = getUsernameFormatError(formData.admin.username);
      if (formatError) newErrors['admin.username'] = formatError;
    }
    if (!formData.admin.zip_code) newErrors['admin.zip_code'] = 'Required';
    else if (formData.admin.zip_code && String(formData.admin.zip_code).length !== 5) {
      newErrors['admin.zip_code'] = 'Zip code must be exactly 5 digits';
    }
    if (!formData.admin.address_line_1) newErrors['admin.address_line_1'] = 'Required';
    if (!formData.admin.city) newErrors['admin.city'] = 'Required';
    if (!formData.admin.state) newErrors['admin.state'] = 'Required';
    const adminCellError = getPhoneValidationError(formData.admin.cell_phone, { label: 'Cell Phone' });
    if (adminCellError) newErrors['admin.cell_phone'] = adminCellError;

    const adminHomeError = getPhoneValidationError(formData.admin.home_phone, { required: false, label: 'Home Phone' });
    if (adminHomeError) newErrors['admin.home_phone'] = adminHomeError;

    const adminFaxError = getPhoneValidationError(formData.admin.fax, { required: false, label: 'Fax' });
    if (adminFaxError) newErrors['admin.fax'] = adminFaxError;

    if (!formData.admin.email) newErrors['admin.email'] = 'Required';
    else if (!validateEmail(formData.admin.email)) newErrors['admin.email'] = 'Invalid';
    if (!isValidAdminTimeZone(formData.admin.time_zone)) newErrors['admin.time_zone'] = 'Required';
    if (!isEditMode) {
      const pass = formData.admin.password;
      if (!pass) {
        newErrors['admin.password'] = 'Required';
      } else {
        const passErrors = [];
        if (pass.length < 8) passErrors.push('8+ chars');
        if (!/[A-Z]/.test(pass)) passErrors.push('1 uppercase');
        if (!/[a-z]/.test(pass)) passErrors.push('1 lowercase');
        if (!/[0-9]/.test(pass)) passErrors.push('1 number');
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(pass)) passErrors.push('1 special char');
        if (passErrors.length > 0) {
          newErrors['admin.password'] = `Missing: ${passErrors.join(', ')}`;
        }
      }
      if (pass !== formData.admin.confirm_password) newErrors['admin.confirm_password'] = 'Passwords do not match';
    }

    const hasEnabledCycle = formData.billing_cycles.some(cycle => cycle.enabled === true);
    if (!hasEnabledCycle) {
      newErrors.billing_cycles = 'At least one Care Program Billing Cycle must be selected';
    } else {
      const incompleteCycles = formData.billing_cycles.filter(cycle => cycle.enabled && (!cycle.start_date || !cycle.days || !cycle.end_date));
      if (incompleteCycles.length > 0) {
        newErrors.billing_cycles = 'Please select a complete Billing Period (Start Date and Days) for all enabled Care Programs';
      } else if (!hasAtLeastOneRpmMonitoringParameter(formData.billing_cycles)) {
        newErrors.rpm_monitoring_parameters = 'Select at least one Type of Monitoring for RPM';
      }
    }

    const emailNotificationValues = isEvitalsMonitoringPractice(formData.evitals_monitoring)
      ? Object.values(formData.email_notifications)
      : Object.entries(formData.email_notifications)
        .filter(([key]) => key !== 'system_caregiver')
        .map(([, value]) => value);
    const hasEmailNotification = emailNotificationValues.some((value) => value === true);
    if (!hasEmailNotification) {
      newErrors.email_notifications = 'At least one Email Notification must be selected';
    }

    if (logoFile) {
      const logoError = validateImageUploadFile(logoFile, { label: 'Logo' });
      if (logoError) newErrors.practice_logo = logoError;
    }

    const mergedErrors = preserveAvailabilityErrors(errors, newErrors);
    setErrors(mergedErrors);
    return Object.keys(mergedErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.warn(VALIDATION_SUMMARY_MESSAGE);
      return;
    }

    if (formData.tax_id && /^\d{2}-\d{7}$/.test(formData.tax_id)) {
      const taxIdOk = await runTaxIdCheck(formData.tax_id);
      if (taxIdOk === false) {
        toast.warn(VALIDATION_SUMMARY_MESSAGE);
        return;
      }
    }

    if (isEditMode && !isChanged) {
      toast.info('No changes detected');
      return;
    }

    setIsSubmitting(true);
    try {
      const rpmCycle = formData.billing_cycles.find(c => c.id === 'RPM' && c.enabled);
      const selected_monitoring_types = [];
      if (rpmCycle && rpmCycle.parameters) {
        if (rpmCycle.parameters.blood_pressure) selected_monitoring_types.push(1);
        if (rpmCycle.parameters.blood_glucose) selected_monitoring_types.push(2);
        if (rpmCycle.parameters.weight) selected_monitoring_types.push(3);
      }

      const payload = {
        practice_name: formData.practice_name,
        status: formData.status,
        tax_id: formData.tax_id,
        practice_type: formData.practice_type,
        enrolled_date: formData.enrolled_date,
        evitals_monitoring: formData.evitals_monitoring,
        address_1: formData.primary_contact.address_line_1,
        address_line_2: formData.primary_contact.address_line_2,
        city: formData.primary_contact.city,
        state: formData.primary_contact.state_id,
        zip_code: formData.primary_contact.zip_code,
        phone_1: formData.primary_contact.phone,
        fax_1: formData.primary_contact.fax,
        email_1: formData.primary_contact.email,
        admin_details: {
          ...formData.admin,
          title: formData.admin.title || null,
          title_id: formData.admin.title
            ? (TITLES.find((t) => t.label === formData.admin.title)?.id ?? null)
            : null,
          phone: formData.admin.cell_phone || null,
          cell_phone: formData.admin.home_phone || null,
          phone_1: formData.admin.cell_phone || null,
          phone_2: formData.admin.home_phone || null,
          state_id: formData.admin.state_id,
          status: formData.admin.status === 'Inactive' ? 'Inactive' : 'Active',
          two_way_auth: formData.admin.two_way_auth === 'Enabled' ? 'Enabled' : 'Disabled',
          is_two_way_auth: formData.admin.two_way_auth === 'Enabled' ? 1 : 0,
          id: formData.admin.id ?? currentPractice?.admin_details?.id ?? null,
        },
        billing_cycles: formData.billing_cycles.filter(c => c.enabled),
        selected_monitoring_types,
        buying_listing_device: Boolean(rpmCycle && formData.buying_device),
        leasing_listing_device: Boolean(rpmCycle && formData.leasing_device),
        email_notifications_for_provider: Boolean(formData.email_notifications.provider),
        email_notifications_for_practice_caregiver: Boolean(formData.email_notifications.practice_caregiver),
        email_notifications_for_superadmin: Boolean(formData.email_notifications.admin),
        email_notifications_for_system_caregiver: isEvitalsMonitoringPractice(formData.evitals_monitoring)
          ? Boolean(formData.email_notifications.system_caregiver)
          : false
      };

      // Build FormData so we can include the logo file
      const fd = new FormData();
      if (logoFile) {
        fd.append('practice_logo', logoFile);
      } else if (logoRemoved) {
        fd.append('practice_logo', '');
      } else if (formData.practice_logo) {
        fd.append('practice_logo', formData.practice_logo);
      }
      // Append all scalar fields; nested objects go as JSON strings
      Object.entries(payload).forEach(([key, value]) => {
        if (value === null || value === undefined) {
          fd.append(key, '');
        } else if (typeof value === 'object' && !(value instanceof File)) {
          fd.append(key, JSON.stringify(value));
        } else {
          fd.append(key, String(value));
        }
      });

      let result;
      if (isEditMode) {
        result = await dispatch(updatePractice({ id: editId, practiceData: fd }));
      } else {
        result = await dispatch(createPractice(fd));
      }

      if (createPractice.fulfilled.match(result) || updatePractice.fulfilled.match(result)) {
        toast.success(`Practice ${isEditMode ? 'updated' : 'added'} successfully`);
        navigate('/dashboard');
      } else {
        let errorMsg = result.payload || 'Failed to save practice';
        if (typeof errorMsg === 'string' && errorMsg.includes('Duplicate entry')) {
          const match = errorMsg.match(/Duplicate entry '(.*?)' for key '(.*?)'/);
          if (match) {
            const entryValue = match[1];
            const keyName = match[2].toLowerCase();

            let fieldName = 'This value';
            if (keyName.includes('username') || keyName.includes('usernam')) fieldName = 'The username';
            else if (keyName.includes('tax_id')) {
              fieldName = 'The Tax ID';
              setErrors(prev => ({ ...prev, tax_id: 'This Tax ID is already registered to another practice.' }));
            }
            else if (keyName.includes('practice_name')) fieldName = 'The practice name';
            else if (keyName.includes('email')) fieldName = 'The email address';
            else if (keyName.includes('phone')) fieldName = 'The phone number';

            errorMsg = `${fieldName} "${entryValue}" is already in use. Please use a unique value.`;
          } else {
            errorMsg = 'A record with this information already exists. Please ensure the data is unique.';
          }
        }
        toast.error(errorMsg);
      }
    } catch (err) {
      toast.error('An unexpected error occurred');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => navigate('/dashboard');

  useEffect(() => {
    const handleKeyDown = (event) => {
      handleGlobalModalEscape(event, handleCancel);
    };

    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, []);

  if (isEditMode && (!currentPractice || !isFormInitialized)) {
    return (
      <div className="add-practice-container">
        <FormDetailSkeleton titleLines={1} fieldRows={12} columns={2} showFooter={true} />
      </div>
    );
  }

  return (
    <div className="add-practice-container">
      <div className="add-practice-form-wrapper">
        <div className="add-practice-header-row">
          <h2 className="add-practice-main-title">{isEditMode ? 'Edit Practice' : 'Add Practice'}</h2>
        </div>

        <form onSubmit={handleSubmit} noValidate>

          {/* Left: Practice Detail + Practice Settings | Right: Admin Detail */}
          <div className="ap-form-columns">
            <div className="ap-form-column-left">
              <div className="add-practice-card">
                <div className="add-practice-card-header">
                  <h5>Practice Detail</h5>
                </div>
                <div className="add-practice-card-body">
                  <div className="ap-detail-panel-grid">
                    <div className="ap-form-group">
                      <label>Practice Name<span className="ap-required-star">*</span></label>
                      <input type="text" name="practice_name" value={formData.practice_name} onChange={handleInputChange} className={`ap-input ${errors.practice_name ? 'is-invalid' : ''}`} placeholder="Enter practice name" />
                      {errors.practice_name && <span className="ap-error-msg">{errors.practice_name}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>Practice Type<span className="ap-required-star">*</span></label>
                      <select name="practice_type" value={formData.practice_type} onChange={handleInputChange} className={`ap-input ${errors.practice_type ? 'is-invalid' : ''}`}>
                        <option value="">Select type</option>
                        <option value="Primary Care">Primary Care</option>
                        <option value="Cardiology">Cardiology</option>
                        <option value="Internal Medicine">Internal Medicine</option>
                        <option value="Family Medicine">Family Medicine</option>
                      </select>
                      {errors.practice_type && <span className="ap-error-msg">{errors.practice_type}</span>}
                    </div>

                    <div className="ap-form-group">
                      <label>Status<span className="ap-required-star">*</span></label>
                      <select name="status" value={formData.status} onChange={handleInputChange} className="ap-input">
                        {PRACTICE_STATUS_OPTIONS.map((option) => (
                          <option key={option} value={option}>{option}</option>
                        ))}
                      </select>
                    </div>
                    <div className="ap-form-group">
                      <label>Enrolled Date<span className="ap-required-star">*</span></label>
                      <AppDateInput
                        value={formData.enrolled_date || ''}
                        onChange={(iso) => {
                          if (iso) {
                            setFormData(prev => ({ ...prev, enrolled_date: iso }));
                            setErrors(prev => { const { enrolled_date, ...rest } = prev; return rest; });
                          } else {
                            setFormData(prev => ({ ...prev, enrolled_date: '' }));
                            setErrors(prev => ({ ...prev, enrolled_date: 'Required' }));
                          }
                        }}
                        max={getTodayDateOnlyLocal()}
                        className={`ap-input ${errors.enrolled_date ? 'is-invalid' : ''}`}
                        wrapperClassName="w-100"
                      />
                      {errors.enrolled_date && <span className="ap-error-msg">{errors.enrolled_date}</span>}
                    </div>

                    <div className="ap-form-group">
                      <label>
                        Tax ID (EIN)<span className="ap-required-star">*</span>
                        {checkingTaxId && <span style={{ fontSize: '11px', color: '#6366f1', marginLeft: '6px' }}>(checking...)</span>}
                      </label>
                      <input
                        type="text"
                        name="tax_id"
                        value={formData.tax_id}
                        onChange={handleInputChange}
                        onBlur={handleTaxIdBlur}
                        className={`ap-input ${errors.tax_id ? 'is-invalid' : ''}`}
                        placeholder="XX-XXXXXXX"
                      />
                      {errors.tax_id && <span className="ap-error-msg">{errors.tax_id}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>eVitals Monitoring<span className="ap-required-star">*</span></label>
                      <select name="evitals_monitoring" value={formData.evitals_monitoring} onChange={handleInputChange} className="ap-input">
                        <option value="Yes">Yes - eVitals monitoring</option>
                        <option value="No">No - Self monitoring</option>
                      </select>
                    </div>

                    <div className="ap-form-group">
                      <label>Email<span className="ap-required-star">*</span></label>
                      <input type="email" name="primary_contact.email" value={formData.primary_contact.email} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.email'] ? 'is-invalid' : ''}`} placeholder="practice@email.com" />
                      {errors['primary_contact.email'] && <span className="ap-error-msg">{errors['primary_contact.email']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>Phone Number<span className="ap-required-star">*</span></label>
                      <PhoneNumberInput name="primary_contact.phone" value={formData.primary_contact.phone} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.phone'] ? 'is-invalid' : ''}`} placeholder="(000) 000-0000" />
                      {errors['primary_contact.phone'] && <span className="ap-error-msg">{errors['primary_contact.phone']}</span>}
                    </div>

                    <div className="ap-form-group">
                      <div className="ap-address-label-row">
                        <label>Address Line 1<span className="ap-required-star">*</span></label>
                        <span className="ap-char-count">{formData.primary_contact.address_line_1?.length || 0}/250</span>
                      </div>
                      <input type="text" name="primary_contact.address_line_1" maxLength="250" value={formData.primary_contact.address_line_1} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.address_line_1'] ? 'is-invalid' : ''}`} placeholder="Street address" />
                      {errors['primary_contact.address_line_1'] && <span className="ap-error-msg">{errors['primary_contact.address_line_1']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <div className="ap-address-label-row">
                        <label>Address Line 2</label>
                        <span className="ap-char-count">{formData.primary_contact.address_line_2?.length || 0}/250</span>
                      </div>
                      <input type="text" name="primary_contact.address_line_2" maxLength="250" value={formData.primary_contact.address_line_2} onChange={handleInputChange} className="ap-input" placeholder="Apt, suite, etc." />
                    </div>

                    <div className="ap-form-group">
                      <label>City<span className="ap-required-star">*</span></label>
                      <input type="text" name="primary_contact.city" value={formData.primary_contact.city} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.city'] ? 'is-invalid' : ''}`} placeholder="City" />
                      {errors['primary_contact.city'] && <span className="ap-error-msg">{errors['primary_contact.city']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>State<span className="ap-required-star">*</span></label>
                      <select name="primary_contact.state" value={formData.primary_contact.state} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.state'] ? 'is-invalid' : ''}`}>
                        <option value="">Select</option>
                        {US_STATES.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                      </select>
                      {errors['primary_contact.state'] && <span className="ap-error-msg">{errors['primary_contact.state']}</span>}
                    </div>

                    <div className="ap-form-group">
                      <label>Fax</label>
                      <PhoneNumberInput name="primary_contact.fax" value={formData.primary_contact.fax} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.fax'] ? 'is-invalid' : ''}`} placeholder="(000) 000-0000" />
                      {errors['primary_contact.fax'] && <span className="ap-error-msg">{errors['primary_contact.fax']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>Zip Code<span className="ap-required-star">*</span></label>
                      <input type="text" name="primary_contact.zip_code" value={formData.primary_contact.zip_code} onChange={handleInputChange} className={`ap-input ${errors['primary_contact.zip_code'] ? 'is-invalid' : ''}`} placeholder="00000" maxLength="5" />
                      {errors['primary_contact.zip_code'] && <span className="ap-error-msg">{errors['primary_contact.zip_code']}</span>}
                    </div>

                    <div className="ap-form-group ap-col-span-2">
                      <label>Practice Logo</label>
                      <div className="ap-logo-field">
                        <input
                          type="text"
                          className={`ap-input ${errors.practice_logo ? 'is-invalid' : ''}`}
                          readOnly
                          placeholder="No file chosen (max 1 MB)"
                          value={logoFile ? logoFile.name : (formData.practice_logo ? formData.practice_logo.split('/').pop() : '')}
                          onClick={() => logoInputRef.current && logoInputRef.current.click()}
                        />
                        <button type="button" className="ap-logo-upload-btn" onClick={() => logoInputRef.current && logoInputRef.current.click()}>
                          <FontAwesomeIcon icon={faCloudUploadAlt} /> Upload
                        </button>
                        <input
                          ref={logoInputRef}
                          type="file"
                          accept="image/png,image/jpeg,image/gif,image/webp"
                          style={{ display: 'none' }}
                          onChange={handleLogoChange}
                        />
                        {(logoFile || (!logoRemoved && formData.practice_logo)) && (
                          <>
                            <img
                              src={
                                logoFile
                                  ? logoPreviewObjectUrlRef.current
                                  : resolvePracticeLogoUrl(formData.practice_logo, {
                                    cacheBust: currentPractice?.updated_at || currentPractice?.id
                                  })
                              }
                              alt="Logo Preview"
                              className="ap-logo-preview"
                              onError={(e) => { e.target.style.display = 'none'; }}
                            />
                            <button type="button" className="ap-logo-remove-btn" onClick={handleRemoveLogo}>✕</button>
                          </>
                        )}
                      </div>
                      {errors.practice_logo && <span className="ap-error-msg">{errors.practice_logo}</span>}
                    </div>
                  </div>
                </div>
              </div>

              <div className="add-practice-card ap-practice-settings-card">
                <div className="add-practice-card-header">
                  <h5>Practice Settings <span className="ap-required-star">*</span></h5>
                </div>
                <div className="add-practice-card-body">
                  {errors.email_notifications && <div className="ap-error-msg mb-3">{errors.email_notifications}</div>}
                  <div className="ap-settings-box">
                    <div className="ap-settings-title">Email Notifications</div>
                    <div className="ap-settings-desc">Send notifications when a new patient is enrolled</div>
                    <div className="ap-checkbox-list">
                      <div className="ap-checkbox-item">
                        <input type="checkbox" id="email_provider" name="email_notifications.provider" checked={formData.email_notifications.provider} onChange={handleInputChange} />
                        <label htmlFor="email_provider">Provider</label>
                      </div>
                      <div className="ap-checkbox-item">
                        <input type="checkbox" id="email_caregiver" name="email_notifications.practice_caregiver" checked={formData.email_notifications.practice_caregiver} onChange={handleInputChange} />
                        <label htmlFor="email_caregiver">Practice Caregiver</label>
                      </div>
                      <div className="ap-checkbox-item">
                        <input type="checkbox" id="email_admin" name="email_notifications.admin" checked={formData.email_notifications.admin} onChange={handleInputChange} />
                        <label htmlFor="email_admin">Admin</label>
                      </div>
                      {isEvitalsMonitoringPractice(formData.evitals_monitoring) && (
                        <div className="ap-checkbox-item">
                          <input type="checkbox" id="email_system" name="email_notifications.system_caregiver" checked={formData.email_notifications.system_caregiver} onChange={handleInputChange} />
                          <label htmlFor="email_system">System Caregiver</label>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="ap-form-column-right">
              <div className="add-practice-card">
                <div className="add-practice-card-header">
                  <h5>Admin Detail</h5>
                </div>
                <div className="add-practice-card-body">
                  <div className="ap-detail-panel-grid">
                    <div className="ap-form-group">
                      <label>Title</label>
                      <select name="admin.title" value={formData.admin.title} onChange={handleInputChange} className={`ap-input ${errors['admin.title'] ? 'is-invalid' : ''}`}>
                        <option value="">Select Title</option>
                        {TITLES.map(t => <option key={t.id} value={t.label}>{t.label}</option>)}
                      </select>
                      {errors['admin.title'] && <span className="ap-error-msg">{errors['admin.title']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>First Name<span className="ap-required-star">*</span></label>
                      <input type="text" name="admin.first_name" value={formData.admin.first_name} onChange={handleInputChange} className={`ap-input ${errors['admin.first_name'] ? 'is-invalid' : ''}`} placeholder="First name" />
                      {errors['admin.first_name'] && <span className="ap-error-msg">{errors['admin.first_name']}</span>}
                    </div>

                    <div className="ap-form-group">
                      <label>Middle Name</label>
                      <input type="text" name="admin.middle_initial" value={formData.admin.middle_initial} onChange={handleInputChange} className="ap-input" placeholder="Middle name" maxLength="20" />
                    </div>
                    <div className="ap-form-group">
                      <label>Last Name<span className="ap-required-star">*</span></label>
                      <input type="text" name="admin.last_name" value={formData.admin.last_name} onChange={handleInputChange} className={`ap-input ${errors['admin.last_name'] ? 'is-invalid' : ''}`} placeholder="Last name" />
                      {errors['admin.last_name'] && <span className="ap-error-msg">{errors['admin.last_name']}</span>}
                    </div>

                    <div className="ap-form-group">
                      <label>Cell Phone<span className="ap-required-star">*</span></label>
                      <PhoneNumberInput name="admin.cell_phone" value={formData.admin.cell_phone} onChange={handleInputChange} className={`ap-input ${errors['admin.cell_phone'] ? 'is-invalid' : ''}`} placeholder="(000) 000-0000" />
                      {errors['admin.cell_phone'] && <span className="ap-error-msg">{errors['admin.cell_phone']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>Home Phone</label>
                      <PhoneNumberInput name="admin.home_phone" value={formData.admin.home_phone} onChange={handleInputChange} className={`ap-input ${errors['admin.home_phone'] ? 'is-invalid' : ''}`} placeholder="(000) 000-0000" />
                      {errors['admin.home_phone'] && <span className="ap-error-msg">{errors['admin.home_phone']}</span>}
                    </div>

                    <div className="ap-form-group">
                      <label>Email<span className="ap-required-star">*</span></label>
                      <input type="email" name="admin.email" autoComplete="off" value={formData.admin.email} onChange={handleInputChange} onPaste={(e) => handleEmailPaste(e, setErrors, 'admin.email')} className={`ap-input ${errors['admin.email'] ? 'is-invalid' : ''}`} placeholder="admin@email.com" />
                      {errors['admin.email'] && <span className="ap-error-msg">{errors['admin.email']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>Fax</label>
                      <PhoneNumberInput name="admin.fax" value={formData.admin.fax} onChange={handleInputChange} className={`ap-input ${errors['admin.fax'] ? 'is-invalid' : ''}`} placeholder="(000) 000-0000" />
                      {errors['admin.fax'] && <span className="ap-error-msg">{errors['admin.fax']}</span>}
                    </div>

                    <div className="ap-form-group">
                      <label>Username<span className="ap-required-star">*</span></label>
                      <input type="text" name="admin.username" autoComplete="off" value={formData.admin.username} onChange={handleInputChange} onPaste={(e) => { if (!isEditMode || excludeUserId) handleUsernamePaste(e, setErrors, 'admin.username'); }} onBlur={() => { if (!isEditMode || excludeUserId) handleUsernameBlur(formData.admin.username, setErrors, 'admin.username'); }} className={`ap-input ${errors['admin.username'] ? 'is-invalid' : ''}`} placeholder="Username" maxLength={USERNAME_MAX_LENGTH} />
                      {errors['admin.username'] && <span className="ap-error-msg">{errors['admin.username']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>Password{!isEditMode && <span className="ap-required-star">*</span>}</label>
                      <div className="ap-password-wrapper">
                        <input type={showPassword ? 'text' : 'password'} name="admin.password" autoComplete="new-password" value={formData.admin.password} onChange={handleInputChange} className={`ap-input ${errors['admin.password'] ? 'is-invalid' : ''}`} placeholder={isEditMode ? 'Leave blank to keep current' : 'Enter password'} onFocus={() => setShowPasswordCriteria(true)} onBlur={() => setShowPasswordCriteria(false)} />
                        <button type="button" className="ap-password-toggle" onClick={() => setShowPassword(!showPassword)}>
                          <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </button>
                        {showPasswordCriteria && (
                          <div className="ap-password-criteria-block">
                            <div className={`ap-criteria-item ${formData.admin.password.length >= 8 ? 'fulfilled' : ''}`}>
                              <FontAwesomeIcon icon={formData.admin.password.length >= 8 ? faCheckCircle : faCircle} className="ap-criteria-icon" /> Minimum 8 characters
                            </div>
                            <div className={`ap-criteria-item ${/[A-Z]/.test(formData.admin.password) ? 'fulfilled' : ''}`}>
                              <FontAwesomeIcon icon={/[A-Z]/.test(formData.admin.password) ? faCheckCircle : faCircle} className="ap-criteria-icon" /> At least 1 Uppercase letter
                            </div>
                            <div className={`ap-criteria-item ${/[a-z]/.test(formData.admin.password) ? 'fulfilled' : ''}`}>
                              <FontAwesomeIcon icon={/[a-z]/.test(formData.admin.password) ? faCheckCircle : faCircle} className="ap-criteria-icon" /> At least 1 Lowercase letter
                            </div>
                            <div className={`ap-criteria-item ${/[0-9]/.test(formData.admin.password) ? 'fulfilled' : ''}`}>
                              <FontAwesomeIcon icon={/[0-9]/.test(formData.admin.password) ? faCheckCircle : faCircle} className="ap-criteria-icon" /> At least 1 Number
                            </div>
                            <div className={`ap-criteria-item ${/[!@#$%^&*(),.?":{}|<>]/.test(formData.admin.password) ? 'fulfilled' : ''}`}>
                              <FontAwesomeIcon icon={/[!@#$%^&*(),.?":{}|<>]/.test(formData.admin.password) ? faCheckCircle : faCircle} className="ap-criteria-icon" /> At least 1 Special character
                            </div>
                          </div>
                        )}
                      </div>
                      {errors['admin.password'] && <span className="ap-error-msg">{errors['admin.password']}</span>}
                    </div>

                    <div className="ap-form-group">
                      <label>Confirm Password{!isEditMode && <span className="ap-required-star">*</span>}</label>
                      <div className="ap-password-wrapper">
                        <input type={showConfirmPassword ? 'text' : 'password'} name="admin.confirm_password" value={formData.admin.confirm_password} onChange={handleInputChange} className={`ap-input ${errors['admin.confirm_password'] ? 'is-invalid' : ''}`} placeholder={isEditMode ? 'Leave blank to keep current' : 'Re-enter password'} />
                        <button type="button" className="ap-password-toggle" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                          <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                        </button>
                      </div>
                      {errors['admin.confirm_password'] && <span className="ap-error-msg">{errors['admin.confirm_password']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>Time Zone<span className="ap-required-star">*</span></label>
                      <select name="admin.time_zone" value={formData.admin.time_zone} onChange={handleInputChange} className={`ap-input ${errors['admin.time_zone'] ? 'is-invalid' : ''}`}>
                        <option value="">Select Time Zone</option>
                        {TIME_ZONES && TIME_ZONES.map(tz => <option key={tz} value={tz}>{tz}</option>)}
                      </select>
                      {errors['admin.time_zone'] && <span className="ap-error-msg">{errors['admin.time_zone']}</span>}
                    </div>

                    <p className="ap-password-hint">Password criteria checklist appears on focus.</p>

                    <div className="ap-form-group">
                      <div className="ap-address-label-row">
                        <label>Address Line 1<span className="ap-required-star">*</span></label>
                        <span className="ap-char-count">{formData.admin.address_line_1?.length || 0}/250</span>
                      </div>
                      <input type="text" name="admin.address_line_1" maxLength="250" value={formData.admin.address_line_1} onChange={handleInputChange} className={`ap-input ${errors['admin.address_line_1'] ? 'is-invalid' : ''}`} placeholder="Street address" />
                      {errors['admin.address_line_1'] && <span className="ap-error-msg">{errors['admin.address_line_1']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <div className="ap-address-label-row">
                        <label>Address Line 2</label>
                        <span className="ap-char-count">{formData.admin.address_line_2?.length || 0}/250</span>
                      </div>
                      <input type="text" name="admin.address_line_2" maxLength="250" value={formData.admin.address_line_2} onChange={handleInputChange} className="ap-input" placeholder="Apt, suite, etc." />
                    </div>

                    <div className="ap-form-group">
                      <label>City<span className="ap-required-star">*</span></label>
                      <input type="text" name="admin.city" value={formData.admin.city} onChange={handleInputChange} className={`ap-input ${errors['admin.city'] ? 'is-invalid' : ''}`} placeholder="City" />
                      {errors['admin.city'] && <span className="ap-error-msg">{errors['admin.city']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>State<span className="ap-required-star">*</span></label>
                      <select name="admin.state" value={formData.admin.state} onChange={handleInputChange} className={`ap-input ${errors['admin.state'] ? 'is-invalid' : ''}`}>
                        <option value="">Select</option>
                        {US_STATES.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                      </select>
                      {errors['admin.state'] && <span className="ap-error-msg">{errors['admin.state']}</span>}
                    </div>

                    <div className="ap-form-group">
                      <label>Zip Code<span className="ap-required-star">*</span></label>
                      <input type="text" name="admin.zip_code" value={formData.admin.zip_code} onChange={handleInputChange} className={`ap-input ${errors['admin.zip_code'] ? 'is-invalid' : ''}`} placeholder="00000" maxLength="5" />
                      {errors['admin.zip_code'] && <span className="ap-error-msg">{errors['admin.zip_code']}</span>}
                    </div>
                    <div className="ap-form-group">
                      <label>Status<span className="ap-required-star">*</span></label>
                      <select name="admin.status" value={formData.admin.status} onChange={handleInputChange} className="ap-input">
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>

                    <div className="ap-form-group">
                      <label>Two Way Authentication<span className="ap-required-star">*</span></label>
                      <select name="admin.two_way_auth" value={formData.admin.two_way_auth} onChange={handleInputChange} className="ap-input">
                        <option value="Disabled">Disabled</option>
                        <option value="Enabled">Enabled</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Billing Cycles — full width */}
          <div className="add-practice-card ap-form-billing-full" style={{ marginBottom: 0 }}>
            <div className="add-practice-card-header">
              <h5>Care Program Billing Cycles <span className="ap-required-star">*</span></h5>
            </div>
            <div className="add-practice-card-body">
              {errors.billing_cycles && <div className="ap-error-msg mb-3">{errors.billing_cycles}</div>}
              <div className="ap-table-wrapper">
                <table className="ap-table">
                  <thead>
                    <tr>
                      <th className="ap-index-col">#</th>
                      <th className="ap-program-col">PROGRAM NAME</th>
                      <th className="ap-date-col">START DATE</th>
                      <th className="ap-days-col">DAYS</th>
                      <th className="ap-date-col">END DATE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.billing_cycles.map((cycle, index) => (
                      <React.Fragment key={cycle.id}>
                        <tr className={!cycle.enabled ? 'ap-disabled-row' : ''}>
                          <td className="ap-index-col">{index + 1}</td>
                          <td className="ap-program-col">
                            <div className="ap-program-cell">
                              <input
                                type="checkbox"
                                className="ap-program-enable-checkbox"
                                checked={cycle.enabled}
                                onChange={(e) => handleBillingCycleChange(index, 'enabled', e.target.checked)}
                                aria-label={`Enable ${cycle.program}`}
                              />
                              <div className={`ap-program-icon ${cycle.iconClass}`} style={{ color: cycle.badgeColor || undefined }}>
                                <FontAwesomeIcon icon={cycle.icon} />
                              </div>
                              <span className="ap-program-name">{cycle.program}</span>
                            </div>
                          </td>
                          <td className="ap-date-col">
                            <AppDateInput
                              value={cycle.start_date || ''}
                              onChange={(iso) => handleBillingCycleChange(index, 'start_date', iso || '')}
                              max={getTodayDateOnlyLocal()}
                              className={`ap-table-input ${!cycle.enabled ? 'ap-disabled-input' : ''}`}
                              disabled={!cycle.enabled}
                              wrapperClassName="ap-datepicker-wrap"
                            />
                          </td>
                          <td className="ap-days-col">
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              maxLength={5}
                              value={cycle.days}
                              onChange={(e) => handleBillingCycleChange(index, 'days', e.target.value)}
                              onKeyDown={(e) => {
                                if (e.ctrlKey || e.metaKey || e.altKey) return;
                                const allowed = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter'];
                                if (allowed.includes(e.key)) return;
                                if (!/^\d$/.test(e.key)) e.preventDefault();
                              }}
                              className="ap-table-input"
                              disabled={!cycle.enabled || !cycle.start_date}
                              placeholder="# days"
                            />
                          </td>
                          <td className="ap-date-col">
                            <AppDateInput
                              value={cycle.end_date || ''}
                              onChange={(iso) => handleBillingCycleChange(index, 'end_date', iso || '')}
                              min={cycle.start_date || undefined}
                              className={`ap-table-input ${(!cycle.enabled || !cycle.start_date) ? 'ap-disabled-input' : ''}`}
                              disabled={!cycle.enabled || !cycle.start_date}
                              wrapperClassName="ap-datepicker-wrap"
                            />
                          </td>
                        </tr>
                        {cycle.id === 'RPM' && cycle.enabled && (
                          <tr className="ap-rpm-parameters-row">
                            <td className="ap-index-col"></td>
                            <td className="ap-program-col" colSpan={4}>
                              {errors.rpm_monitoring_parameters && (
                                <div className="ap-error-msg" style={{ marginBottom: 8 }}>{errors.rpm_monitoring_parameters}</div>
                              )}
                              <div className="ap-rpm-parameters">
                                <div className="ap-rpm-group">
                                  <span className="ap-param-label">Type of Monitoring <span className="ap-required-star">*</span></span>
                                  {RPM_MONITORING_PARAMETER_KEYS.map(param => (
                                    <div key={param} className="ap-param-item">
                                      <input
                                        type="checkbox"
                                        id={`param_${param}`}
                                        checked={Boolean(cycle.parameters?.[param])}
                                        onChange={(e) => handleRpmParameterChange(param, e.target.checked)}
                                      />
                                      <label htmlFor={`param_${param}`}>{RPM_PARAMETER_LABELS[param] || param.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}</label>
                                    </div>
                                  ))}
                                </div>
                                <div className="ap-rpm-group">
                                  <span className="ap-param-label">Buying Device</span>
                                  <label className="ap-param-item" htmlFor="rpm_buying_device_yes">
                                    <input
                                      type="radio"
                                      id="rpm_buying_device_yes"
                                      name="rpm_buying_device"
                                      checked={formData.buying_device === true}
                                      onChange={() => handleRpmDeviceFlagChange('buying_device', true)}
                                    />
                                    Yes
                                  </label>
                                  <label className="ap-param-item" htmlFor="rpm_buying_device_no">
                                    <input
                                      type="radio"
                                      id="rpm_buying_device_no"
                                      name="rpm_buying_device"
                                      checked={formData.buying_device === false}
                                      onChange={() => handleRpmDeviceFlagChange('buying_device', false)}
                                    />
                                    No
                                  </label>
                                </div>
                                <div className="ap-rpm-group">
                                  <span className="ap-param-label">Leasing Device</span>
                                  <label className="ap-param-item" htmlFor="rpm_leasing_device_yes">
                                    <input
                                      type="radio"
                                      id="rpm_leasing_device_yes"
                                      name="rpm_leasing_device"
                                      checked={formData.leasing_device === true}
                                      onChange={() => handleRpmDeviceFlagChange('leasing_device', true)}
                                    />
                                    Yes
                                  </label>
                                  <label className="ap-param-item" htmlFor="rpm_leasing_device_no">
                                    <input
                                      type="radio"
                                      id="rpm_leasing_device_no"
                                      name="rpm_leasing_device"
                                      checked={formData.leasing_device === false}
                                      onChange={() => handleRpmDeviceFlagChange('leasing_device', false)}
                                    />
                                    No
                                  </label>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="ap-actions">
            {isEditMode && (
              <button
                type="button"
                className="ap-btn ap-btn-event-logs"
                onClick={() => setShowEventLogsModal(true)}
                title="View Practice Event Logs"
              >
                <FontAwesomeIcon icon={faList} className="me-2" />
                Event Logs
              </button>
            )}
            <div className="ap-actions-right">
              <button type="button" className="ap-btn ap-btn-cancel" onClick={handleCancel}>Cancel</button>
              <button type="submit" className="ap-btn ap-btn-save" disabled={isSubmitting || storeIsSubmitting || (isEditMode && !isChanged)}>
                {isSubmitting || storeIsSubmitting ? <><FontAwesomeIcon icon={faSpinner} spin className="me-2" /> {isEditMode ? 'Updating...' : 'Saving...'}</> : (isEditMode ? 'UPDATE' : 'SAVE')}
              </button>
            </div>
          </div>
        </form>
      </div>

      {showEventLogsModal && isEditMode && (
        <div
          ref={logOverlayRef}
          className="practices-list-modal-overlay"
          style={{ zIndex: 110000 }}
        >
          <div
            ref={logContainerRef}
            className="practices-list-modal-container"
            style={{ maxWidth: '900px', width: '90%' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="practices-list-modal-header">
              <h5 className="practices-list-modal-title" style={{ margin: 0 }}>
                {formData.practice_name ? `${formData.practice_name} — Event Logs` : 'Practice Event Logs'}
              </h5>
              <button
                type="button"
                className="practices-list-modal-close"
                onClick={() => setShowEventLogsModal(false)}
              >
                ×
              </button>
            </div>
            <div className="practices-list-modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              <EventLogSection moduleId="Practice" practiceId={editId} />
            </div>
          </div>
        </div>
      )}

      <Modal show={showValidationModal} onHide={() => setShowValidationModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <div className="mb-3">
            <FontAwesomeIcon icon={faInfoCircle} size="3x" className="text-danger" />
          </div>
          <h4 className="mb-4">Please fill all required fields</h4>
          <button className="ap-btn ap-btn-save mx-auto" onClick={() => setShowValidationModal(false)}>OK</button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddPractice;